import type { Lang } from "@noli/core";

export enum Editor_Words {
  "delete" = "delete",
  "size-reset" = "size-reset",
  "size-reset-no-need-message" = "size-reset-no-need-message",
  "size-string-template" = "size-string-template",
  "on-fire-message" = "on-fire-message",
  "task-limit-message" = "task-limit-message",
  "create-new-node" = "create-new-node",
  "create-new-node-success-message" = "create-new-node-success-message",
  "loading-image-message" = "loading-image-message",
  "cloud-save-success-message" = "cloud-save-success-message",
  "cloud-save-failed-message" = "cloud-save-failed-message",
  "unrecognized-meta-type-warning-message" = "unrecognized-meta-type-warning-message",
  "cannot-find-node-warning-message" = "cannot-find-node-warning-message",
  "max-wh-warning-message" = "max-wh-warning-message",
  "import-global" = "import-global",
  "download-global" = "download-global",
  "importing-global-message" = "importing-global-message",
  "import-global-success-message" = "import-global-success-message",
  "import-global-failed-message" = "import-global-failed-message",
  "downloading-message" = "downloading-message",
  "auto-arrange" = "auto-arrange",
  "auto-arrange-message" = "auto-arrange-message",
  "current-node-type" = "current-node-type",
  "text-placeholder" = "text-placeholder",
  "noliFrame-placeholder" = "noliFrame-placeholder",
  "textarea-placeholder" = "textarea-placeholder",
  "import-placeholder" = "import-placeholder",
  "txt2img-inpainting-placeholder" = "txt2img-inpainting-placeholder",
  "negative-prompt-placeholder" = "negative-prompt-placeholder",
  "no-node" = "no-node",
  "blank-node" = "blank-node",
  "image-node" = "image-node",
  "download-image-size" = "download-image-size",
  "download-image-size-original" = "download-image-size-original",
  "download-image-size-on-board" = "download-image-size-on-board",
  "num-tasks-in-queue" = "num-tasks-in-queue",
  "num-tasks-message-prefix" = "num-tasks-message-prefix",
  "num-tasks-message-postfix" = "num-tasks-message-postfix",
  "no-text-input-message" = "no-text-input-message",
  "no-selecting-node-message" = "no-selecting-node-message",
  "already-in-queue-message" = "already-in-queue-message",
  "free-task-already-in-queue-message" = "free-task-already-in-queue-message",
  "submit-success-message" = "submit-success-message",
  "generate-success-message" = "generate-success-message",
  "txt2img-sd-title" = "txt2img-sd-title",
  "txt2img-sd-submit-and-add" = "txt2img-sd-submit-and-add",
  "txt2img-sd-submit-and-fill" = "txt2img-sd-submit-and-fill",
  "txt2img-sd-submit-and-add-template" = "txt2img-sd-submit-and-add-template",
  "txt2img-sd-submit-and-sr" = "txt2img-sd-submit-and-sr",
  "txt2img-sd-tooltip" = "txt2img-sd-tooltip",
  "txt2img-sd-circular" = "txt2img-sd-circular",
  "txt2img-sd-anime" = "txt2img-sd-anime",
  "txt2img-sd-variation-title" = "txt2img-sd-variation-title",
  "txt2img-sd-variation-submit" = "txt2img-sd-variation-submit",
  "txt2img-sd-variation-submit-and-add-template" = "txt2img-sd-variation-submit-and-add-template",
  "txt2img-sd-variation-not-support-message" = "txt2img-sd-variation-not-support-message",
  "txt2img-sd-style-title" = "txt2img-sd-style-title",
  "txt2img-sd-artist-title" = "txt2img-sd-artist-title",
  "txt2img-sd-size-title" = "txt2img-sd-size-title",
  "txt2img-sd-size-message" = "txt2img-sd-size-message",
  "txt2img-sd-recommend-title" = "txt2img-sd-recommend-title",
  "txt2img-sd-high-res" = "txt2img-sd-high-res",
  "load-preset-success-message" = "load-preset-success-message",
  "img2img-sd-title" = "img2img-sd-title",
  "img2img-sd-submit" = "img2img-sd-submit",
  "img2img-sd-submit-and-add-template" = "img2img-sd-submit-and-add-template",
  "img2img-sd-tooltip" = "img2img-sd-tooltip",
  "txt2img-inpainting-title" = "txt2img-inpainting-title",
  "txt2img-inpainting-mark-image" = "txt2img-inpainting-mark-image",
  "txt2img-inpainting-mark-mask" = "txt2img-inpainting-mark-mask",
  "txt2img-inpainting-submit" = "txt2img-inpainting-submit",
  "txt2img-inpainting-submit-and-add-template" = "txt2img-inpainting-submit-and-add-template",
  "fidelity" = "fidelity",
  "negative-prompt-title" = "negative-prompt-title",
  "negative-prompt-submit" = "negative-prompt-submit",
  "negative-prompt-not-support-message" = "negative-prompt-not-support-message",
  "import-title" = "import-title",
  "import-submit" = "import-submit",
  "share-title" = "share-title",
  "copy-parameters" = "copy-parameters",
  "copy-parameters-success-message" = "copy-parameters-success-message",
  "download-parameters" = "download-parameters",
  "arrangeParameters" = "arrangeParameters",
  "image-process-title" = "image-process-title",
  "super-resolution" = "super-resolution",
  "super-resolution-anime" = "super-resolution-anime",
  "picture-merging" = "picture-merging",
  "picture-merging-mark-background" = "picture-merging-mark-background",
  "picture-merging-mark-foreground" = "picture-merging-mark-foreground",
  "picture-merging-submit" = "picture-merging-submit",
  "inpainting" = "inpainting",
  "inpainting-mark-image" = "inpainting-mark-image",
  "inpainting-mark-mask" = "inpainting-mark-mask",
  "inpainting-submit" = "inpainting-submit",
  "inpainting-refine-submit" = "inpainting-refine-submit",
  "outpainting" = "outpainting",
  "outpainting-mark-area" = "outpainting-mark-area",
  "outpainting-submit" = "outpainting-submit",
  "dropping-message" = "dropping-message",
  "uploading-message" = "uploading-message",
  "upload-seccess-message" = "upload-seccess-message",
  "add-to-board-success-message" = "add-to-board-success-message",
  "add-to-board-error-message" = "add-to-board-error-message",
  "landscape-types" = "landscape-types",
  "landscape-clouds" = "landscape-clouds",
  "landscape-grass" = "landscape-grass",
  "landscape-hill" = "landscape-hill",
  "landscape-mountain" = "landscape-mountain",
  "landscape-river" = "landscape-river",
  "landscape-rock" = "landscape-rock",
  "landscape-sea" = "landscape-sea",
  "landscape-sky-other" = "landscape-sky-other",
  "landscape-stone" = "landscape-stone",
  "landscape-tree" = "landscape-tree",
  "landscape-water-other" = "landscape-water-other",
  "landscape-ground-other" = "landscape-ground-other",
  "landscape-synthesis-submit" = "landscape-synthesis-submit",
  "none-style" = "none-style",
  "oil-painting-style" = "oil-painting-style",
  "water-color-style" = "water-color-style",
  "sketch-style" = "sketch-style",
  "cartoon-style" = "cartoon-style",
  "chinese-painting-style" = "chinese-painting-style",
  "photograph-style" = "photograph-style",
  "anime-style" = "anime-style",
  "neon-game-style" = "neon-game-style",
  "cg-style" = "cg-style",
  "ghibli-style" = "ghibli-style",
  "crystal-punk-style" = "crystal-punk-style",
  "psychedelic-style" = "psychedelic-style",
  "low-poly-style" = "low-poly-style",
  "pixel-style" = "pixel-style",
  "matte-painting-style" = "matte-painting-style",
  "interior-design-style" = "interior-design-style",
  "cyberpunk-style" = "cyberpunk-style",
  "vaporwave-style" = "vaporwave-style",
  "impressionism-style" = "impressionism-style",
  "futurism-style" = "futurism-style",
  "epic-style" = "epic-style",
  "ukiyo-e-style" = "ukiyo-e-style",
  "retrowave-palette-style" = "retrowave-palette-style",
  "city-pop-style" = "city-pop-style",
  "chinese-new-style" = "chinese-new-style",
  "none-artist" = "none-artist",
  "daVinci-artist" = "daVinci-artist",
  "van-gogh-artist" = "van-gogh-artist",
  "vermeer-artist" = "vermeer-artist",
  "rembrandt-artist" = "rembrandt-artist",
  "durer-artist" = "durer-artist",
  "picasso-artist" = "picasso-artist",
  "cezanne-artist" = "cezanne-artist",
  "monet-artist" = "monet-artist",
  "ingres-artist" = "ingres-artist",
  "mucha-artist" = "mucha-artist",
  "ghibli-artist" = "ghibli-artist",
  "matisse-artist" = "matisse-artist",
  "dali-artist" = "dali-artist",
  "mondrian-artist" = "mondrian-artist",
  "fengzikai-artist" = "fengzikai-artist",
  "wuguanzhong-artist" = "wuguanzhong-artist",
  "zhangdaqian-artist" = "zhangdaqian-artist",
  "recommend_1" = "recommend_1",
  "recommend_2" = "recommend_2",
  "recommend_3" = "recommend_3",
  "recommend_4" = "recommend_4",
  "recommend_5" = "recommend_5",
  "recommend_6" = "recommend_6",
  "recommend_7" = "recommend_7",
  "recommend_8" = "recommend_8",
  "recommend_9" = "recommend_9",
  "recommend_10" = "recommend_10",
  "recommend_11" = "recommend_11",
  "recommend_12" = "recommend_12",
  "recommend_13" = "recommend_13",
  "recommend_14" = "recommend_14",
  "recommend_15" = "recommend_15",
  "recommend_16" = "recommend_16",
  "recommend_17" = "recommend_17",
  "recommend_18" = "recommend_18",
  "recommend_19" = "recommend_19",
  "recommend_20" = "recommend_20",
  "recommend_21" = "recommend_21",
  "recommend_22" = "recommend_22",
  "recommend_23" = "recommend_23",
  "recommend_24" = "recommend_24",
  "recommend_25" = "recommend_25",
  "recommend_26" = "recommend_26",
  "recommend_27" = "recommend_27",
  "generate-cats-panel-title" = "generate-cats-panel-title",
  "generate-cats-category" = "generate-cats-category",
  "generate-cats-description" = "generate-cats-description",
  "none-cat" = "none-cat",
  "yingduan-cat" = "yingduan-cat",
  "jiafei-cat" = "jiafei-cat",
  "buou-cat" = "buou-cat",
  "jumao-cat" = "jumao-cat",
  "bosi-cat" = "bosi-cat",
  "meiduan-cat" = "meiduan-cat",
  "xianluo-cat" = "xianluo-cat",
  "xinjiapo-cat" = "xinjiapo-cat",
  "ximalaya-cat" = "ximalaya-cat",
  "sikeke-cat" = "sikeke-cat",
  "zhonghuatianyuan-cat" = "zhonghuatianyuan-cat",
  "mianyin-cat" = "mianyin-cat",
  "wumaomao-cat" = "wumaomao-cat",
  "node-type-error-message" = "node-type-error-message",
  "negative-prompt-error-message" = "negative-prompt-error-message",
  "import-error-message" = "import-error-message",
  "no-overlap-error-message" = "no-overlap-error-message",
  "upload-image-error-message" = "upload-image-error-message",
  "upload-image-not-safe-warning-message" = "upload-image-not-safe-warning-message",
  "strange-image-error-message" = "strange-image-error-message",
  "download-image-error-message" = "download-image-error-message",
  "landscape-synthesis-error-message" = "landscape-synthesis-error-message",
  "get-prompt-warning-message" = "get-prompt-warning-message",
  "get-prompt-not-safe-warning-message" = "get-prompt-not-safe-warning-message",
  "post-creator-error-message" = "post-creator-error-message",
  "post-creator-captcha-warn-message" = "post-creator-captcha-warn-message",
  "post-creator-not-safe-warning-message" = "post-creator-not-safe-warning-message",
  "export-blob-error-message" = "export-blob-error-message",
  "update-op-error-message" = "update-op-error-message",
  "add-blank-error-message" = "add-blank-error-message",
  "add-text-error-message" = "add-text-error-message",
  "add-image-error-message" = "add-image-error-message",
  "auto-arrange-no-need-message" = "auto-arrange-no-need-message",
  "auto-arrange-no-nodes-message" = "auto-arrange-no-nodes-message",
  "EXCEED_LIMIT" = "EXCEED_LIMIT",
  "UN_SUPPORT" = "UN_SUPPORT",
  "PARSE_ERROR" = "PARSE_ERROR",
  "use-local-server" = "use-local-server",
  "local-server-host" = "local-server-host",
  "use-local-model" = "use-local-model",
  "local-model-version" = "local-model-version",
  "local-model-name" = "local-model-name",
  "switch-local-model" = "switch-local-model",
  "switch-local-model-submit-message" = "switch-local-model-submit-message",
  "switch-local-model-success-message" = "switch-local-model-success-message",
  "switch-local-model-error-message" = "switch-local-model-error-message",
  "reset-local-model" = "reset-local-model",
  "reset-local-model-submit-message" = "reset-local-model-submit-message",
  "reset-local-model-success-message" = "reset-local-model-success-message",
  "reset-local-model-error-message" = "reset-local-model-error-message",
  "local-model-root" = "local-model-root",
  "switch-local-model-root" = "switch-local-model-root",
  "switch-local-model-root-submit-message" = "switch-local-model-root-submit-message",
  "switch-local-model-root-success-message" = "switch-local-model-root-success-message",
  "switch-local-model-root-error-message" = "switch-local-model-root-error-message",
  "tokens-root" = "tokens-root",
  "refresh-tokens" = "refresh-tokens",
  "refresh-tokens-submit-message" = "refresh-tokens-submit-message",
  "refresh-tokens-success-message" = "refresh-tokens-success-message",
  "refresh-tokens-error-message" = "refresh-tokens-error-message",
  "creator-sd.inpainting-task" = "creator-sd.inpainting-task",
  "creator-outpainting-task" = "creator-outpainting-task",
  "creator-inpainting-task" = "creator-inpainting-task",
  "creator-semantic2img-task" = "creator-semantic2img-task",
  "creator-txt2img.variation-task" = "creator-txt2img.variation-task",
  "creator-txt2img-task" = "creator-txt2img-task",
  "creator-img2img.variation-task" = "creator-img2img.variation-task",
  "creator-img2img-task" = "creator-img2img-task",
  "creator-sr.anime-task" = "creator-sr.anime-task",
  "creator-sr-task" = "creator-sr-task",
  "creator-txt2img.inpainting-task" = "creator-txt2img.inpainting-task",
  "creator-txt2img.outpainting-task" = "creator-txt2img.outpainting-task",
  "creator-landscape-task" = "creator-landscape-task",
  "creator-working-message" = "creator-working-message",
  "pending-position" = "pending-position",
  "pending-time" = "pending-time",
  "contact-us" = "contact-us",
  "join-community-message" = "join-community-message",
  "sponsor-message" = "sponsor-message",
  "visit-github-message" = "visit-github-message",
  "email-author-message" = "email-author-message",
  "image-render-type" = "image-render-type",
  "ai-parameters-appendix" = "ai-parameters-appendix",
  "menu_link-to-gallery" = "menu_link-to-gallery",
  "header_link-to-gallery" = "header_link-to-gallery",
  "gen-img_link-to-gallery" = "gen-img_link-to-gallery",
  "post-to-gallery" = "post-to-gallery",
  "message_post_sensitive-check-failed" = "message_post_sensitive-check-failed",
  "message_post_success" = "message_post_success",
  "message_post_failed" = "message_post_failed",
  "header_post-art-work" = "header_post-art-work",
  "label_title" = "label_title",
  "label_description" = "label_description",
  "label_prompt-public" = "label_prompt-public",
  "explanation_prompt-public" = "explanation_prompt-public",
  "label_art-work" = "label_art-work",
  "tip_reorder-on-dragging" = "tip_reorder-on-dragging",
  "button_confirm-to-post" = "button_confirm-to-post",
  "button_cancel" = "button_cancel",
  "message_post-only-support-image" = "message_post-only-support-image",
  "message_post-only-support-image-and-select-again" = "message_post-only-support-image-and-select-again",
  "message_post-max-count-and-select-again" = "message_post-max-count-and-select-again",
  "message_post-select" = "message_post-select",
  "validate_no-empty-title" = "validate_no-empty-title",
  "validate_no-empty-description" = "validate_no-empty-description",
  "validate_description-over-limit" = "validate_description-over-limit",
  "validate_title-over-limit" = "validate_title-over-limit",
  "feedback" = "feedback",
  "right-panel-tab-operations" = "right-panel-tab-operations",
  "right-panel-tab-inspiration" = "right-panel-tab-inspiration",
  size = "size",
  "stay-in-step-with-selected-pic" = "stay-in-step-with-selected-pic",
  model = "model",
  resolution = "resolution",
  "select-a-picture" = "select-a-picture",
  "select-a-ai-picture" = "select-a-ai-picture",
  "anime-model" = "anime-model",
  "anime-model-intro" = "anime-model-intro",
  "nolibox-model" = "nolibox-model",
  "nolibox-model-intro" = "nolibox-model-intro",
  "left-nav-txt2img" = "left-nav-txt2img",
  "left-nav-variation" = "left-nav-variation",
  "left-nav-img2img" = "left-nav-img2img",
  "left-nav-hd" = "left-nav-hd",
  "left-nav-inpaint" = "left-nav-inpaint",
  "left-nav-eraser" = "left-nav-eraser",
  "left-nav-matting" = "left-nav-matting",
  "left-nav-edit" = "left-nav-edit",
  "left-nav-negative-prompt" = "left-nav-negative-prompt",
  "left-nav-outpaint" = "left-nav-outpaint",
  "left-nav-cat" = "left-nav-cat",
  "left-nav-presets" = "left-nav-presets",
  "left-nav-param" = "left-nav-param",
  "choose-a-model" = "choose-a-model",
  "choose-negaprompt-source" = "choose-negaprompt-source",
  "negaprompt-input" = "negaprompt-input",
  "params2txt-input-title" = "params2txt-input-title",
  "params2txt-input-desc" = "params2txt-input-desc",
  "txt2img-title" = "txt2img-title",
  "general-loading" = "general-loading",
  "choose-super-resolution-source" = "choose-super-resolution-source",
  "img2img-placeholder-title" = "img2img-placeholder-title",
  "img2img-prompt-title" = "img2img-prompt-title",
  "img2img-prompt-placeholder" = "img2img-prompt-placeholder",
  "prompt-for-img" = "prompt-for-img",
  "current-select-not-image" = "current-select-not-image",
  "current-select-not-ai-image" = "current-select-not-ai-image",
  "current_select_not_for_variation" = "current_select_not_for_variation",
  "current_select_not_for_negative_prompt" = "current_select_not_for_negative_prompt",
  "prompt-for-img-input-placeholder" = "prompt-for-img-input-placeholder",
  "local-replace-image-placeholder-title" = "local-replace-image-placeholder-title",
  "local-erase-image-placeholder-title" = "local-erase-image-placeholder-title",
  "local-replace-mask-placeholder-title" = "local-replace-mask-placeholder-title",
  "local-erase-mask-placeholder-title" = "local-erase-mask-placeholder-title",
  "current-select-not-path" = "current-select-not-path",
  "select-a-path" = "select-a-path",
  "local-replace-content" = "local-replace-content",
  "mode-simple" = "mode-simple",
  "mode-advance" = "mode-advance",
  "choose-a-mode" = "choose-a-mode",
  "preset-type-acg" = "preset-type-acg",
  "preset-type-cat" = "preset-type-cat",
  "action-guide-and-shortcut" = "action-guide-and-shortcut",
  "prompt-word-table-title" = "prompt-word-table-title",
  "negative-prompt-word-table-title" = "negative-prompt-word-table-title",
  "prompt-input-title" = "prompt-input-title",
  "negative-prompt-input-title" = "negative-prompt-input-title",
  "keyword-list-title" = "keyword-list-title",
  "negative-prompt-keyword-list-title" = "negative-prompt-keyword-list-title",
  "use-keyword" = "use-keyword",
  "using-keyword" = "using-keyword",
  "image-content-categories" = "image-content-categories",
  "select-a-picture-or-sketch" = "select-a-picture-or-sketch",
  "current-select-not-a-picture-or-sketch" = "current-select-not-a-picture-or-sketch",
  "header_menu_tip" = "header_menu_tip",
  "header_add-blank_tip" = "header_add-blank_tip",
  "header_add-text_tip" = "header_add-text_tip",
  "header_normal-brush_tip" = "header_normal-brush_tip",
  "header_landscape_tip" = "header_landscape_tip",
  "header_undo_tip" = "header_undo_tip",
  "header_redo_tip" = "header_redo_tip",
  "header_cloud_tip" = "header_cloud_tip",
  "search-not-found" = "search-not-found",
  "negative-prompt-keyword-search-placeholder" = "negative-prompt-keyword-search-placeholder",
  "prompt-keyword-search-placeholder" = "prompt-keyword-search-placeholder",
  "select-all" = "select-all",
  "optimizer" = "optimizer",
  "value-default" = "value-default",
  "value-custom" = "value-custom",
  "label_text_generate_count" = "label_text_generate_count",
  "generate_count_option_label_template" = "generate_count_option_label_template",
  "generate_count_option_label_tip_1" = "generate_count_option_label_tip_1",
  "generate_count_option_label_tip_2" = "generate_count_option_label_tip_2",
  "generate_count_option_label_tip_3" = "generate_count_option_label_tip_3",
  "outpainting-preview-title" = "outpainting-preview-title",
  "outpainting-text-title" = "outpainting-text-title",
  "select-a-blank-node" = "select-a-blank-node",
  "current-select-not-blank-node" = "current-select-not-blank-node",
  "inspiration_tab_gallery" = "inspiration_tab_gallery",
  "inspiration_tab_album" = "inspiration_tab_album",
  "label_select_an_image" = "label_select_an_image",
  "label_select_style" = "label_select_style",
  "express_generate_btn_text" = "express_generate_btn_text",
  "express_generate_btn_loading_text" = "express_generate_btn_loading_text",
  "img2promopt_failed_message" = "img2promopt_failed_message",
  "presets_panel_title" = "presets_panel_title",
  "cloud_project_switch" = "cloud_project_switch",
  "cloud_project_create" = "cloud_project_create",
  "cloud_project_rename" = "cloud_project_rename",
  "cloud_project_rename_label" = "cloud_project_rename_label",
  "cloud_project_rename_failed_toast" = "cloud_project_rename_failed_toast",
  "cloud_project_rename_success_toast" = "cloud_project_rename_success_toast",
  "current_project_lost_id" = "current_project_lost_id",
  "select_a_cloud_project" = "select_a_cloud_project",
  "cloud_project_switch_header" = "cloud_project_switch_header",
  "cancel_button" = "cancel_button",
  "switch_cloud_project_button_text" = "switch_cloud_project_button_text",
  "save_as_new_project_reason" = "save_as_new_project_reason",
  "cloud_project_switch_success" = "cloud_project_switch_success",
  "cloud_project_switch_failed" = "cloud_project_switch_failed",
  "cloud_project_create_success" = "cloud_project_create_success",
  "cloud_project_create_failed" = "cloud_project_create_failed",
  "create_cloud_project_header" = "create_cloud_project_header",
  "rename_for_new_project" = "rename_for_new_project",
  "create_new_project_button_text" = "create_new_project_button_text",
  "cloud_project_name_sensitive_toast" = "cloud_project_name_sensitive_toast",
  "scroll_load_more" = "scroll_load_more",
  "submitToPublic" = "submitToPublic",
  "current_select_is_not_origin_image" = "current_select_is_not_origin_image",
  "select_an_image_uncut" = "select_an_image_uncut",
  "cutout_button_text" = "cutout_button_text",
  "cutout_failed_message" = "cutout_failed_message",
  "cutouting_message" = "cutouting_message",
  "cutout_title" = "cutout_title",
  "cloud_project_shown_all" = "cloud_project_shown_all",
  "end-brush" = "end-brush",
  "sampler-title" = "sampler-title",
  "num-steps-caption" = "num-steps-caption",
  "guidance-scale-caption" = "guidance-scale-caption",
  "seed-caption" = "seed-caption",
  "nolibox_matt_model" = "nolibox_matt_model",
  "cardboard-search" = "cardboard-search",
  "cardboard-search-placeholder" = "cardboard-search-placeholder",
  "community-model" = "community-model",
  "community-model-provider" = "community-model-provider",
  "monkey-product-name" = "monkey-product-name",
  "technique-support" = "technique-support",
  "creator-wenxin-task" = "creator-wenxin-task",
  "creator-wenxin-img2img-task" = "creator-wenxin-img2img-task",
  "creator-monkey-task" = "creator-monkey-task",
  "creator-monkey-img2img-task" = "creator-monkey-img2img-task",
  "cloud_save_tooltip_with_time" = "cloud_save_tooltip_with_time",
  "cloud_save_info_with_time" = "cloud_save_info_with_time",
  "cloud_saving" = "cloud_saving",
  "creator-draft-task" = "creator-draft-task",
  "creator-draft-img2img-task" = "creator-draft-img2img-task",
  "cancel_all_nolibox_tasks" = "cancel_all_nolibox_tasks",
  "replace_cancel_task_tip" = "replace_cancel_task_tip",
  "replace_cancel_tasks_confirm" = "replace_cancel_tasks_confirm",
  "replace_cancel_tasks_cancel" = "replace_cancel_tasks_cancel",
  "cancel_tasks_success" = "cancel_tasks_success",
  "cancel_tasks_failed" = "cancel_tasks_failed",
  "create_project_cancel_tasks_tip" = "create_project_cancel_tasks_tip",
  "create_project_cancel_tasks_confirm" = "create_project_cancel_tasks_confirm",
  "cloud_switch_modal_update_time" = "cloud_switch_modal_update_time",
  "cloud_switch_modal_current_project" = "cloud_switch_modal_current_project",
  "cloud_switch_modal_enter_project" = "cloud_switch_modal_enter_project",
  "cloud_switch_modal_delete_project" = "cloud_switch_modal_delete_project",
  "cloud_switch_modal_download_project" = "cloud_switch_modal_download_project",
  "cloud_switch_modal_load_more" = "cloud_switch_modal_load_more",
  "cloud_project_header_op_icon_tooltip" = "cloud_project_header_op_icon_tooltip",
  "cloud_project_delete_modal_warn" = "cloud_project_delete_modal_warn",
  "cloud_project_delete_modal_confirm" = "cloud_project_delete_modal_confirm",
  "variation_usable_tooltip_text" = "variation_usable_tooltip_text",
  "negative_prompt_usable_tooltip_text" = "negative_prompt_usable_tooltip_text",
  "acg_generate_btn_text" = "acg_generate_btn_text",
  "upload_image_to_board" = "upload_image_to_board",
  "Or" = "Or",
  "dreamlike-model" = "dreamlike-model",
  "dreamlike-model-intro" = "dreamlike-model-intro",
  "deliberate-general" = "deliberate-general",
  "epicrealisim-real" = "epicrealisim-real",
  "anime" = "anime",
  "dreamlike" = "dreamlike",
  "revanime-3d-anime" = "revanime-3d-anime",
  "prompt-expand-placeholder" = "prompt-expand-placeholder",
  "prompt-expand" = "prompt-expand",
  "prompt-expand-modal-title" = "prompt-expand-modal-title",
}

export const editorLangRecords: Record<Lang, Record<Editor_Words, string>> = {
  zh: {
    [Editor_Words["delete"]]: "删 除",
    [Editor_Words["size-reset"]]: "尺寸恢复",
    [Editor_Words["size-reset-no-need-message"]]: "当前节点已是原始尺寸！😉",
    [Editor_Words["size-string-template"]]: "已选中 $1 个节点",
    [Editor_Words["on-fire-message"]]:
      "当前服务器有点火爆 🔥 您可以尝试使用「百度文心」模型，生成不排队，且能一次性生成三张高清大图 😆",
    [Editor_Words["task-limit-message"]]:
      "您已经提交了 $1 个任务，而且当前服务器有点火爆 🔥，请稍候 😉",
    [Editor_Words["create-new-node"]]: "新增空白节点",
    [Editor_Words["create-new-node-success-message"]]: "添加空白节点成功！🥳",
    [Editor_Words["loading-image-message"]]: "图片仍在加载中，请稍候 😉",
    [Editor_Words["cloud-save-success-message"]]: "云端保存成功！🥳",
    [Editor_Words["cloud-save-failed-message"]]:
      "云端保存失败，请检查您的网络环境 😫 为保证数据不丢失，可将项目保存到本地 😉",
    [Editor_Words["unrecognized-meta-type-warning-message"]]: "出现了未知参数类型 😫：",
    [Editor_Words["cannot-find-node-warning-message"]]: "想要进行操作的节点失踪了…… 😫",
    [Editor_Words["max-wh-warning-message"]]: "提交的尺寸$1超过了最大尺寸$2！😫",
    [Editor_Words["import-global"]]: "在当前项目中导入本地 .noli",
    [Editor_Words["download-global"]]: "将当前项目 .noli 下载到本地",
    [Editor_Words["importing-global-message"]]: "导入中，请稍候 😉",
    [Editor_Words["import-global-success-message"]]: "导入成功！🥳",
    [Editor_Words["import-global-failed-message"]]: "导入失败！😫",
    [Editor_Words["downloading-message"]]: "下载中，请稍候 😉",
    [Editor_Words["auto-arrange"]]: "智能整理",
    [Editor_Words["auto-arrange-message"]]: "整理中，请稍候 😉",
    [Editor_Words["current-node-type"]]: "当前节点类型",
    [Editor_Words["text-placeholder"]]: "请输入文字",
    [Editor_Words["noliFrame-placeholder"]]: "请输入文字",
    [Editor_Words["textarea-placeholder"]]: "输入文字，比如：“一朵红色玫瑰花，水彩”",
    [Editor_Words["import-placeholder"]]: "输入 AI 参数",
    [Editor_Words["txt2img-inpainting-placeholder"]]: "输入想加入的内容",
    [Editor_Words["negative-prompt-placeholder"]]: "输入避免生成的内容，比如：“黄色”、“人”",
    [Editor_Words["no-node"]]: "无",
    [Editor_Words["blank-node"]]: "空白节点",
    [Editor_Words["image-node"]]: "图像节点",
    [Editor_Words["download-image-size"]]: "下载尺寸",
    [Editor_Words["download-image-size-original"]]: "原始尺寸",
    [Editor_Words["download-image-size-on-board"]]: "画板尺寸",
    [Editor_Words["num-tasks-in-queue"]]: "执行中任务数",
    [Editor_Words["num-tasks-message-prefix"]]: "正在执行",
    [Editor_Words["num-tasks-message-postfix"]]: "个 AI 任务",
    [Editor_Words["no-text-input-message"]]: "当前未输入文字信息 😉",
    [Editor_Words["no-selecting-node-message"]]: "当前未选中节点 😉",
    [Editor_Words["already-in-queue-message"]]: "该节点 / 操作已在执行队列中，请稍候 😆",
    [Editor_Words["free-task-already-in-queue-message"]]: "该节点 / 操作已在执行队列中，请稍候 😆",
    [Editor_Words["submit-success-message"]]:
      "提交成功！结果预计将在十几秒左右生成完毕，您可以先进行其它操作 😄",
    [Editor_Words["generate-success-message"]]: "已成功生成图像！🥳",
    [Editor_Words["txt2img-sd-title"]]: "生成新图片",
    [Editor_Words["txt2img-sd-submit-and-add"]]: "生成并添加",
    [Editor_Words["txt2img-sd-submit-and-fill"]]: "生成并填充",
    [Editor_Words["txt2img-sd-submit-and-add-template"]]: "生成 $1 张 并添加",
    [Editor_Words["txt2img-sd-submit-and-sr"]]: "高清生成",
    [Editor_Words["txt2img-sd-tooltip"]]: "按照输入的文字，生成「新的」图像",
    [Editor_Words["txt2img-sd-circular"]]: "生成循环纹样",
    [Editor_Words["txt2img-sd-anime"]]: "使用动漫生成模型",
    [Editor_Words["txt2img-sd-variation-title"]]: "相似图片生成",
    [Editor_Words["txt2img-sd-variation-submit"]]: "生成并添加",
    [Editor_Words["txt2img-sd-variation-submit-and-add-template"]]: "生成 $1 张 并添加",
    [Editor_Words["txt2img-sd-variation-not-support-message"]]: "当前图片不支持生成相似图片 😫",
    [Editor_Words["txt2img-sd-style-title"]]: "风格",
    [Editor_Words["txt2img-sd-artist-title"]]: "艺术家",
    [Editor_Words["txt2img-sd-size-title"]]: "尺寸",
    [Editor_Words["txt2img-sd-size-message"]]: "尺寸由选中节点的尺寸决定 😉",
    [Editor_Words["txt2img-sd-recommend-title"]]: "可以试试",
    [Editor_Words["txt2img-sd-high-res"]]: "高清生成",
    [Editor_Words["load-preset-success-message"]]: "加载成功！🥳",
    [Editor_Words["img2img-sd-title"]]: "转换图片（垫图生成）",
    [Editor_Words["img2img-sd-submit"]]: "转换并添加",
    [Editor_Words["img2img-sd-submit-and-add-template"]]: "转换 $1 张 并添加",
    [Editor_Words["img2img-sd-tooltip"]]: "根据输入的文字，「转换」选中的图像",
    [Editor_Words["txt2img-inpainting-title"]]: "图片局部替换",
    [Editor_Words["txt2img-inpainting-mark-image"]]: "标记为底图",
    [Editor_Words["txt2img-inpainting-mark-mask"]]: "标记为待替换区域",
    [Editor_Words["txt2img-inpainting-submit"]]: "替换并添加",
    [Editor_Words["txt2img-inpainting-submit-and-add-template"]]: "替换 $1 张 并添加",
    [Editor_Words["fidelity"]]: "原图相似度",
    [Editor_Words["negative-prompt-title"]]: "去除图片中的内容",
    [Editor_Words["negative-prompt-submit"]]: "去除并添加",
    [Editor_Words["negative-prompt-not-support-message"]]: "当前图片不支持去除内容 😫",
    [Editor_Words["import-title"]]: "通过 AI 参数生成",
    [Editor_Words["import-submit"]]: "生成并添加",
    [Editor_Words["share-title"]]: "分享",
    [Editor_Words["copy-parameters"]]: "复制",
    [Editor_Words["copy-parameters-success-message"]]: "复制成功 🥳",
    [Editor_Words["download-parameters"]]: "下载参数",
    [Editor_Words.arrangeParameters]: "调参",
    [Editor_Words["image-process-title"]]: "图片变高清(超分辨率)",
    [Editor_Words["super-resolution"]]: "变高清并添加",
    [Editor_Words["super-resolution-anime"]]: "超分辨率（动漫）",
    [Editor_Words["picture-merging"]]: "图像融合",
    [Editor_Words["picture-merging-mark-background"]]: "标记为背景",
    [Editor_Words["picture-merging-mark-foreground"]]: "标记为前景",
    [Editor_Words["picture-merging-submit"]]: "融合",
    [Editor_Words["inpainting"]]: "图片局部消除",
    [Editor_Words["inpainting-mark-image"]]: "标记为图像",
    [Editor_Words["inpainting-mark-mask"]]: "标记为待消除区域",
    [Editor_Words["inpainting-submit"]]: "消 除",
    [Editor_Words["inpainting-refine-submit"]]: "精 修",
    [Editor_Words["outpainting"]]: "图像外延",
    [Editor_Words["outpainting-mark-area"]]: "标记为待填补区域",
    [Editor_Words["outpainting-submit"]]: "外 延",
    [Editor_Words["dropping-message"]]: "识别中 🤔",
    [Editor_Words["uploading-message"]]: "上传中，请稍候 😄",
    [Editor_Words["upload-seccess-message"]]: "上传成功！🥳",
    [Editor_Words["landscape-types"]]: "风景种类",
    [Editor_Words["landscape-clouds"]]: "云",
    [Editor_Words["landscape-grass"]]: "草",
    [Editor_Words["landscape-hill"]]: "丘陵",
    [Editor_Words["landscape-mountain"]]: "山",
    [Editor_Words["landscape-river"]]: "河",
    [Editor_Words["landscape-rock"]]: "岩石",
    [Editor_Words["landscape-sea"]]: "海",
    [Editor_Words["landscape-sky-other"]]: "天空",
    [Editor_Words["landscape-stone"]]: "石头",
    [Editor_Words["landscape-tree"]]: "树",
    [Editor_Words["landscape-water-other"]]: "水",
    [Editor_Words["landscape-ground-other"]]: "地面",
    [Editor_Words["landscape-synthesis-submit"]]: "合成风景",
    [Editor_Words["none-style"]]: "不限",
    [Editor_Words["oil-painting-style"]]: "油画",
    [Editor_Words["water-color-style"]]: "水彩画",
    [Editor_Words["sketch-style"]]: "素描",
    [Editor_Words["cartoon-style"]]: "卡通画",
    [Editor_Words["chinese-painting-style"]]: "中国画",
    [Editor_Words["photograph-style"]]: "摄影",
    [Editor_Words["anime-style"]]: "动漫",
    [Editor_Words["neon-game-style"]]: "霓虹游戏",
    [Editor_Words["cg-style"]]: "CG",
    [Editor_Words["ghibli-style"]]: "吉卜力",
    [Editor_Words["crystal-punk-style"]]: "水晶朋克",
    [Editor_Words["psychedelic-style"]]: "迷幻",
    [Editor_Words["low-poly-style"]]: "低聚",
    [Editor_Words["pixel-style"]]: "像素",
    [Editor_Words["matte-painting-style"]]: "哑光",
    [Editor_Words["interior-design-style"]]: "室内设计",
    [Editor_Words["cyberpunk-style"]]: "赛博朋克",
    [Editor_Words["vaporwave-style"]]: "蒸汽波",
    [Editor_Words["impressionism-style"]]: "印象派",
    [Editor_Words["futurism-style"]]: "未来主义",
    [Editor_Words["epic-style"]]: "史诗",
    [Editor_Words["ukiyo-e-style"]]: "浮世绘",
    [Editor_Words["retrowave-palette-style"]]: "逆波",
    [Editor_Words["city-pop-style"]]: "城市pop",
    [Editor_Words["chinese-new-style"]]: "新中式",
    [Editor_Words["none-artist"]]: "不限",
    [Editor_Words["daVinci-artist"]]: "达芬奇",
    [Editor_Words["van-gogh-artist"]]: "梵高",
    [Editor_Words["vermeer-artist"]]: "维米尔",
    [Editor_Words["rembrandt-artist"]]: "伦勃朗",
    [Editor_Words["durer-artist"]]: "丢勒",
    [Editor_Words["picasso-artist"]]: "毕加索",
    [Editor_Words["cezanne-artist"]]: "塞尚",
    [Editor_Words["monet-artist"]]: "莫奈",
    [Editor_Words["ingres-artist"]]: "安格尔",
    [Editor_Words["mucha-artist"]]: "穆夏",
    [Editor_Words["ghibli-artist"]]: "宫崎骏",
    [Editor_Words["matisse-artist"]]: "马蒂斯",
    [Editor_Words["dali-artist"]]: "达利",
    [Editor_Words["mondrian-artist"]]: "蒙德里安",
    [Editor_Words["fengzikai-artist"]]: "丰子恺",
    [Editor_Words["wuguanzhong-artist"]]: "吴冠中",
    [Editor_Words["zhangdaqian-artist"]]: "张大千",
    [Editor_Words["recommend_1"]]: "云端天梯",
    [Editor_Words["recommend_2"]]: "未来街道",
    [Editor_Words["recommend_3"]]: "白精灵美女",
    [Editor_Words["recommend_4"]]: "复古跑车",
    [Editor_Words["recommend_5"]]: "花丛少女",
    [Editor_Words["recommend_6"]]: "炫彩头像",
    [Editor_Words["recommend_7"]]: "沙漠绿洲",
    [Editor_Words["recommend_8"]]: "解忧杂货店",
    [Editor_Words["recommend_9"]]: "梦幻都市",
    [Editor_Words["recommend_10"]]: "暗黑机械市民",
    [Editor_Words["recommend_11"]]: "美少女模型",
    [Editor_Words["recommend_12"]]: "绿灯侠漫画",
    [Editor_Words["recommend_13"]]: "神奇的洛丽塔女孩肖像",
    [Editor_Words["recommend_14"]]: "圣光女子",
    [Editor_Words["recommend_15"]]: "赛博朋克新哥特女战士",
    [Editor_Words["recommend_16"]]: "华丽克苏鲁3号",
    [Editor_Words["recommend_17"]]: "戴面纱的半机械美女",
    [Editor_Words["recommend_18"]]: "朦胧圣殿遗址",
    [Editor_Words["recommend_19"]]: "游戏概念",
    [Editor_Words["recommend_20"]]: "赛博机甲",
    [Editor_Words["recommend_21"]]: "未来城市设计",
    [Editor_Words["recommend_22"]]: "漫画城堡",
    [Editor_Words["recommend_23"]]: "华丽的蒸汽朋克",
    [Editor_Words["recommend_24"]]: "梦幻迪士尼",
    [Editor_Words["recommend_25"]]: "智能生化实验室",
    [Editor_Words["recommend_26"]]: "身临太空舱",
    [Editor_Words["recommend_27"]]: "哥特式夜野幻想",
    [Editor_Words["generate-cats-panel-title"]]: "生成猫猫 🐱",
    [Editor_Words["generate-cats-category"]]: "猫猫品种",
    [Editor_Words["generate-cats-description"]]: "补充描述",
    [Editor_Words["none-cat"]]: "不限",
    [Editor_Words["yingduan-cat"]]: "英短",
    [Editor_Words["jiafei-cat"]]: "加菲",
    [Editor_Words["buou-cat"]]: "布偶",
    [Editor_Words["bosi-cat"]]: "波斯猫",
    [Editor_Words["xianluo-cat"]]: "暹罗猫",
    [Editor_Words["meiduan-cat"]]: "美短",
    [Editor_Words["jumao-cat"]]: "橘猫",
    [Editor_Words["xinjiapo-cat"]]: "新加坡猫",
    [Editor_Words["ximalaya-cat"]]: "喜马拉雅猫",
    [Editor_Words["sikeke-cat"]]: "斯可可",
    [Editor_Words["zhonghuatianyuan-cat"]]: "田园猫",
    [Editor_Words["mianyin-cat"]]: "缅因",
    [Editor_Words["wumaomao-cat"]]: "无毛猫",
    [Editor_Words["node-type-error-message"]]: "当前节点的类型有些古怪 😫",
    [Editor_Words["negative-prompt-error-message"]]: "当前节点无法去除内容 😫",
    [Editor_Words["import-error-message"]]: "当前输入的参数有些问题 😫",
    [Editor_Words["no-overlap-error-message"]]: "需要有重叠区域 😆",
    [Editor_Words["strange-image-error-message"]]: "图片类型错误，当前仅支持上传 jpg/png 图片 😫",
    [Editor_Words["upload-image-error-message"]]: "上传图片失败 😫",
    [Editor_Words["upload-image-not-safe-warning-message"]]: "您上传的图片未通过审核 😫",
    [Editor_Words["download-image-error-message"]]: "下载图片失败 😫",
    [Editor_Words["landscape-synthesis-error-message"]]: "合成风景图失败 😫",
    [Editor_Words["get-prompt-warning-message"]]:
      "中文文本优化器出了些问题 😫 如果结果不符合预期，请尝试使用英文输入 😉",
    [Editor_Words["get-prompt-not-safe-warning-message"]]: "您输入的文字未通过审核 😫",
    [Editor_Words["post-creator-error-message"]]: "请求算法服务时出了些问题，可以再试一次 😫",
    [Editor_Words["post-creator-captcha-warn-message"]]: "当日任务提交量较大，您已触发人机校验",
    [Editor_Words["post-creator-not-safe-warning-message"]]:
      "生成的图片未通过审核，可以再试一次 😫",
    [Editor_Words["export-blob-error-message"]]: "导出节点时出了些问题 😫",
    [Editor_Words["update-op-error-message"]]: "更新节点时出了些问题 😫",
    [Editor_Words["add-blank-error-message"]]: "添加空白节点时出了些问题 😫",
    [Editor_Words["add-text-error-message"]]: "添加文字时出了些问题 😫",
    [Editor_Words["add-image-error-message"]]: "添加图片时出了些问题 😫",
    [Editor_Words["auto-arrange-no-need-message"]]: "当前节点无需整理 😉",
    [Editor_Words["auto-arrange-no-nodes-message"]]: "当前画板上没有节点 😫",
    [Editor_Words["EXCEED_LIMIT"]]: "图片大小/图片像素过大 😫",
    [Editor_Words["UN_SUPPORT"]]: "图片类型错误，当前仅支持上传 jpg/png 图片 😫",
    [Editor_Words["PARSE_ERROR"]]: "图片解析失败 😫",
    [Editor_Words["use-local-server"]]: "使用本地服务",
    [Editor_Words["local-server-host"]]: "本地服务地址",
    [Editor_Words["use-local-model"]]: "使用本地模型",
    [Editor_Words["local-model-version"]]: "版本",
    [Editor_Words["local-model-name"]]: "模型",
    [Editor_Words["switch-local-model"]]: "切换本地模型",
    [Editor_Words["switch-local-model-submit-message"]]: "切换本地模型中",
    [Editor_Words["switch-local-model-success-message"]]: "成功切换本地模型 🥳",
    [Editor_Words["switch-local-model-error-message"]]: "切换本地模型失败 😫",
    [Editor_Words["reset-local-model"]]: "重置",
    [Editor_Words["reset-local-model-submit-message"]]: "重置模型中",
    [Editor_Words["reset-local-model-success-message"]]: "成功重置模型 🥳",
    [Editor_Words["reset-local-model-error-message"]]: "重置模型失败 😫",
    [Editor_Words["local-model-root"]]: "本地模型根目录",
    [Editor_Words["switch-local-model-root"]]: "切换根目录",
    [Editor_Words["switch-local-model-root-submit-message"]]: "切换本地模型根目录中",
    [Editor_Words["switch-local-model-root-success-message"]]: "成功切换本地模型根目录 🥳",
    [Editor_Words["switch-local-model-root-error-message"]]: "切换本地模型根目录失败 😫",
    [Editor_Words["tokens-root"]]: "tokens 根目录",
    [Editor_Words["refresh-tokens"]]: "刷新 Tokens",
    [Editor_Words["refresh-tokens-submit-message"]]: "刷新 tokens 中",
    [Editor_Words["refresh-tokens-success-message"]]: "成功刷新了 tokens 🥳",
    [Editor_Words["refresh-tokens-error-message"]]: "刷新 tokens 失败 😫",
    [Editor_Words["creator-sd.inpainting-task"]]: "图片局部替换",
    [Editor_Words["creator-outpainting-task"]]: "图像外延",
    [Editor_Words["creator-inpainting-task"]]: "图片局部擦除",
    [Editor_Words["creator-semantic2img-task"]]: "风景生成",
    [Editor_Words["creator-txt2img.variation-task"]]: "生成相似图片(文本)",
    [Editor_Words["creator-txt2img-task"]]: "文本生成图片",
    [Editor_Words["creator-img2img.variation-task"]]: "生成相似图片(图片)",
    [Editor_Words["creator-img2img-task"]]: "图片转换",
    [Editor_Words["creator-sr.anime-task"]]: "超分辨率（动漫）",
    [Editor_Words["creator-sr-task"]]: "超分辨率",
    [Editor_Words["creator-txt2img.inpainting-task"]]: "图片局部替换",
    [Editor_Words["creator-txt2img.outpainting-task"]]: "图像外延",
    [Editor_Words["creator-landscape-task"]]: "风景合成",
    [Editor_Words["creator-working-message"]]: "（执行中）",
    [Editor_Words["pending-position"]]: "顺位",
    [Editor_Words["pending-time"]]: "预计等待",
    [Editor_Words["contact-us"]]: "🙋 帮助中心",
    [Editor_Words["feedback"]]: "💡 问题反馈",
    [Editor_Words["join-community-message"]]: "加入社群，和更多创作者交流",
    [Editor_Words["sponsor-message"]]: "微信支付，请作者喝杯咖啡",
    [Editor_Words["visit-github-message"]]: "访问 GitHub 项目",
    [Editor_Words["email-author-message"]]: "给作者发邮件",
    [Editor_Words["image-render-type"]]: "填充方式",
    [Editor_Words["ai-parameters-appendix"]]: "生成参数",
    [Editor_Words["menu_link-to-gallery"]]: "进入艺术展",
    [Editor_Words["header_link-to-gallery"]]: "进入艺术展",
    [Editor_Words["gen-img_link-to-gallery"]]: "进入艺术展，寻找灵感",
    [Editor_Words["post-to-gallery"]]: "发布到艺术展",
    [Editor_Words.submitToPublic]: "提交展出",
    [Editor_Words["message_post_sensitive-check-failed"]]:
      "根据有关内容安全规定，发布失败，您可修改后再次尝试",
    [Editor_Words["message_post_success"]]: "您的作品已提交审核，您可以到我的空间中查看发布进度",
    [Editor_Words["message_post_failed"]]: "发布失败 😫",
    [Editor_Words["header_post-art-work"]]: "发布作品",
    [Editor_Words["label_title"]]: "标题",
    [Editor_Words["label_description"]]: "描述",
    [Editor_Words["label_prompt-public"]]: "公开 Prompt",
    [Editor_Words["label_art-work"]]: "作品",
    [Editor_Words["explanation_prompt-public"]]: "Prompt、初始图片及其他AI操作参数将会被公开",
    [Editor_Words["tip_reorder-on-dragging"]]: "⭐️可按住拖拽进行排序",
    [Editor_Words["button_cancel"]]: "取消",
    [Editor_Words["button_confirm-to-post"]]: "确认发布",
    [Editor_Words["message_post-only-support-image"]]: "只支持发布图片 😳",
    [Editor_Words["message_post-only-support-image-and-select-again"]]:
      "只支持发布图片 😳 请您重新选择",
    [Editor_Words["message_post-max-count-and-select-again"]]:
      "一次最多只可以发布九张图片哟 😳 请您重新选择",
    [Editor_Words["message_post-select"]]: "请选择画板上的图以发布",
    [Editor_Words["validate_no-empty-title"]]: "请输入标题 😉",
    [Editor_Words["validate_no-empty-description"]]: "请输入描述 😉",
    [Editor_Words["validate_title-over-limit"]]: "标题不超过20个汉字 / 20个emoji / 40个英文字母 😳",
    [Editor_Words["validate_description-over-limit"]]:
      "描述不超过140个汉字 / 140个emoji / 280个英文字母 😳",
    [Editor_Words["right-panel-tab-inspiration"]]: "灵感",
    [Editor_Words["right-panel-tab-operations"]]: "属性与操作",
    [Editor_Words["size"]]: "尺寸",
    [Editor_Words["stay-in-step-with-selected-pic"]]: "和选中图片一致",
    [Editor_Words["model"]]: "生成模型",
    [Editor_Words["resolution"]]: "输出分辨率",
    [Editor_Words["select-a-picture"]]: "请选中画板上的图片",
    [Editor_Words["select-a-ai-picture"]]: "请选中画板上的 AI 图片",
    [Editor_Words["anime-model"]]: "画宇宙动漫模型",
    [Editor_Words["anime-model-intro"]]: "画宇宙动漫模型 (基于 Stable Diffusion)",
    [Editor_Words["nolibox-model"]]: "画宇宙模型",
    [Editor_Words["nolibox-model-intro"]]: "画宇宙模型 (基于 Stable Diffusion)",
    [Editor_Words["dreamlike-model"]]: "画宇宙模型2.0",
    [Editor_Words["dreamlike-model-intro"]]: "画宇宙模型2.0",
    [Editor_Words["left-nav-txt2img"]]: "生成",
    [Editor_Words["left-nav-variation"]]: "相似",
    [Editor_Words["left-nav-img2img"]]: "垫图",
    [Editor_Words["left-nav-hd"]]: "高清",
    [Editor_Words["left-nav-inpaint"]]: "替换",
    [Editor_Words["left-nav-eraser"]]: "擦除",
    [Editor_Words["left-nav-matting"]]: "抠图",
    [Editor_Words["left-nav-edit"]]: "调整",
    [Editor_Words["left-nav-negative-prompt"]]: "去除",
    [Editor_Words["left-nav-outpaint"]]: "外延",
    [Editor_Words["left-nav-cat"]]: "猫猫",
    [Editor_Words["left-nav-presets"]]: "玩图",
    [Editor_Words["left-nav-param"]]: "调参",
    [Editor_Words["choose-a-model"]]: "选择模型",
    [Editor_Words["choose-negaprompt-source"]]: "选择需要去除内容的图片",
    [Editor_Words["negaprompt-input"]]: "避免生成的内容",
    [Editor_Words["params2txt-input-title"]]: "AI 参数",
    [Editor_Words["params2txt-input-desc"]]: "你可以在 Gallery 中复制喜欢图片的 AI 参数",
    [Editor_Words["txt2img-title"]]: "文本生成图片",
    [Editor_Words["general-loading"]]: "加载中...",
    [Editor_Words["choose-super-resolution-source"]]: "选择需要高清化的图片：",
    [Editor_Words["img2img-placeholder-title"]]: "选择转换前的原图",
    [Editor_Words["img2img-prompt-title"]]: "转换后画面中的内容",
    [Editor_Words["img2img-prompt-placeholder"]]: "输入文字，比如：“一朵红色玫瑰花，水彩”",
    [Editor_Words["prompt-for-img"]]: "画面中的内容",
    [Editor_Words["current-select-not-image"]]: "当前选中的节点不是图片",
    [Editor_Words["current-select-not-ai-image"]]: "当前选中的节点不是\n画宇宙系列模型\n生成的图片",
    [Editor_Words["current_select_not_for_variation"]]: "当前选中的图片不支持相似功能",
    [Editor_Words["current_select_not_for_negative_prompt"]]: "当前选中的图片不支持去除功能",
    [Editor_Words["variation_usable_tooltip_text"]]:
      "相似功能可应用于由画宇宙模型、画宇宙动漫模型、画宇宙小模型生成的 AI 图片",
    [Editor_Words["negative_prompt_usable_tooltip_text"]]:
      "去除功能可应用于由画宇宙模型、画宇宙动漫模型、画宇宙小模型、社区大模型生成的AI图片",

    [Editor_Words["prompt-for-img-input-placeholder"]]: "请输入画面内容",
    [Editor_Words["local-replace-image-placeholder-title"]]: "选择需要局部替换的图片",
    [Editor_Words["local-erase-image-placeholder-title"]]: "选择需要局部擦除的图片",
    [Editor_Words["local-replace-mask-placeholder-title"]]: "选择待替换区域",
    [Editor_Words["local-erase-mask-placeholder-title"]]: "选择待消除区域",
    [Editor_Words["select-a-path"]]: "请选中画板上的画笔涂鸦",
    [Editor_Words["current-select-not-path"]]: "当前选中节点不是画笔涂鸦",
    [Editor_Words["local-replace-content"]]: "局部替换的内容",
    [Editor_Words["mode-simple"]]: "简易模式",
    [Editor_Words["mode-advance"]]: "高级模式",
    [Editor_Words["choose-a-mode"]]: "选择模式",
    [Editor_Words["sampler-title"]]: "采样器",
    [Editor_Words["num-steps-caption"]]: "采样步数",
    [Editor_Words["guidance-scale-caption"]]: "扣题程度",
    [Editor_Words["seed-caption"]]: "随机种子",
    [Editor_Words["action-guide-and-shortcut"]]: "操作提示与快捷键",
    [Editor_Words["prompt-word-table-title"]]: "指令配置词表：",
    [Editor_Words["negative-prompt-word-table-title"]]: "负指令配置词表：",
    [Editor_Words["prompt-input-title"]]: "指令（Prompt）",
    [Editor_Words["negative-prompt-input-title"]]: "使用负指令（Negative Prompt）",
    [Editor_Words["keyword-list-title"]]: "关键词内容",
    [Editor_Words["use-keyword"]]: "使用",
    [Editor_Words["using-keyword"]]: "使用中",
    [Editor_Words["image-content-categories"]]: "画面内容类别",
    [Editor_Words["select-a-picture-or-sketch"]]: "请选中画板上的图片或\n画笔涂鸦",
    [Editor_Words["current-select-not-a-picture-or-sketch"]]: "当前选中的节点不是图片或画笔涂鸦",
    [Editor_Words["header_menu_tip"]]: "菜单",
    [Editor_Words["header_add-blank_tip"]]: "添加空白画布",
    [Editor_Words["header_add-text_tip"]]: "添加文本",
    [Editor_Words["header_normal-brush_tip"]]: "选区画笔",
    [Editor_Words["header_landscape_tip"]]: "风景画笔",
    [Editor_Words["header_undo_tip"]]: "撤销",
    [Editor_Words["header_redo_tip"]]: "重做",
    [Editor_Words["header_cloud_tip"]]: "保存到云端",
    [Editor_Words["search-not-found"]]: "没有找到相关内容～",
    [Editor_Words["negative-prompt-keyword-list-title"]]: "去除负面效果",
    [Editor_Words["negative-prompt-keyword-search-placeholder"]]: "请输入搜索负面词",
    [Editor_Words["prompt-keyword-search-placeholder"]]: "请输入搜索关键词",
    [Editor_Words["select-all"]]: "全选",
    [Editor_Words["optimizer"]]: "智能优化",
    [Editor_Words["value-default"]]: "默认",
    [Editor_Words["value-custom"]]: "自定义",
    [Editor_Words["label_text_generate_count"]]: "生成张数",
    [Editor_Words["generate_count_option_label_template"]]: `$1 张`,
    [Editor_Words[
      "generate_count_option_label_tip_1"
    ]]: `由于同时生成多张图片对算力消耗较大，为保证用户体验 生成多张的功能仅对使用`,
    [Editor_Words["generate_count_option_label_tip_2"]]: "加速通道",
    [Editor_Words["generate_count_option_label_tip_3"]]: "的用户可用",
    [Editor_Words["outpainting-preview-title"]]: "选择需要外延绘制的空白画布",
    [Editor_Words["outpainting-text-title"]]: "要生成的内容",
    [Editor_Words["select-a-blank-node"]]: "请选中画板上的\n空白画布",
    [Editor_Words["current-select-not-blank-node"]]: "当前选中的节点不是\n空白画布",
    [Editor_Words["inspiration_tab_gallery"]]: "艺术展",
    [Editor_Words["inspiration_tab_album"]]: "我的画册",
    [Editor_Words["preset-type-acg"]]: "照片变二次元",
    [Editor_Words["preset-type-cat"]]: "生成猫猫",
    [Editor_Words["label_select_an_image"]]: "选择图片",
    [Editor_Words["label_select_style"]]: "选择风格",
    [Editor_Words["express_generate_btn_text"]]: "一键生成",
    [Editor_Words["express_generate_btn_loading_text"]]: "生成中",
    [Editor_Words["img2promopt_failed_message"]]: "获取图片信息失败，请稍后再试",
    [Editor_Words.presets_panel_title]: "快速玩转 AI 绘画",
    [Editor_Words["cloud_project_switch"]]: "切换云端项目",
    [Editor_Words["cloud_project_create"]]: "新建项目",
    [Editor_Words["cloud_project_rename"]]: "重命名当前项目",
    [Editor_Words["cloud_project_rename_label"]]: "当前项目重命名为",
    [Editor_Words["cloud_project_rename_failed_toast"]]: "项目名更新失败！",
    [Editor_Words["cloud_project_rename_success_toast"]]: "项目名更新成功",
    [Editor_Words["current_project_lost_id"]]: "当前项目发生了一些错误",
    [Editor_Words["select_a_cloud_project"]]: "请选择一个云端项目！",
    [Editor_Words["cloud_project_switch_header"]]: "云端项目管理",
    [Editor_Words["cancel_button"]]: "取消",
    [Editor_Words["switch_cloud_project_button_text"]]: "切换项目",
    [Editor_Words["save_as_new_project_reason"]]:
      "检测到云端有更新版本，已为您将本地项目另存为新项目：",
    [Editor_Words["cloud_project_switch_success"]]: "项目已切换到",
    [Editor_Words["cloud_project_switch_failed"]]: "项目切换失败",
    [Editor_Words["cloud_project_create_success"]]: "创建项目成功，正在切换项目...",
    [Editor_Words["cloud_project_create_failed"]]: "新建项目失败！",
    [Editor_Words["create_cloud_project_header"]]: "新建项目",
    [Editor_Words["rename_for_new_project"]]: "为新项目命名",
    [Editor_Words["create_new_project_button_text"]]: "新建项目",
    [Editor_Words["cloud_project_name_sensitive_toast"]]: "检测到敏感词汇，请重新输入",
    [Editor_Words["add-to-board-success-message"]]: "加入画板成功 🥳",
    [Editor_Words["add-to-board-error-message"]]: "加入画板失败 😫",
    [Editor_Words.current_select_is_not_origin_image]: "当前选中图片已经过抠图",
    [Editor_Words.select_an_image_uncut]: "请选中画板上的未经抠图的节点",
    [Editor_Words.cutout_button_text]: "抠图并添加",
    [Editor_Words.cutout_failed_message]: "抠图出现了一些问题 😫",
    [Editor_Words.cutout_title]: "智能抠图",
    [Editor_Words.cutouting_message]: "抠图中...",
    [Editor_Words["cloud_project_shown_all"]]: "没有更多项目了~",
    [Editor_Words["end-brush"]]: "确定选区",
    [Editor_Words.nolibox_matt_model]: "画宇宙抠图模型",
    [Editor_Words["cardboard-search"]]: "关键词内容",
    [Editor_Words["cardboard-search-placeholder"]]: "搜索关键词",
    [Editor_Words["community-model"]]: "社区大模型",
    [Editor_Words["community-model-provider"]]: "社区大模型由",
    [Editor_Words["monkey-product-name"]]: "猴子无限",
    [Editor_Words["technique-support"]]: "提供技术支持",
    [Editor_Words["creator-wenxin-task"]]: "文生图（百度文心）",
    [Editor_Words["creator-wenxin-img2img-task"]]: "垫图生成（百度文心）",
    [Editor_Words["creator-monkey-task"]]: "文生图（大模型）",
    [Editor_Words["creator-monkey-img2img-task"]]: "垫图生成（大模型）",
    [Editor_Words["cloud_save_tooltip_with_time"]]: "于 $ 云保存",
    [Editor_Words["cloud_save_info_with_time"]]: "$ 已云保存",
    [Editor_Words["cloud_saving"]]: "正在云保存...",
    [Editor_Words["creator-draft-task"]]: "文生图（Draft）",
    [Editor_Words["creator-draft-img2img-task"]]: "垫图生成（Draft）",
    [Editor_Words["scroll_load_more"]]: "滚动加载更多",
    [Editor_Words["cancel_all_nolibox_tasks"]]: "取消全部画宇宙任务",
    [Editor_Words["replace_cancel_task_tip"]]: "切换项目将取消当前全部任务 😳 您确定要切换吗？",
    [Editor_Words["replace_cancel_tasks_confirm"]]: "切换项目",
    [Editor_Words["replace_cancel_tasks_cancel"]]: "返回",
    [Editor_Words["cancel_tasks_success"]]: "已取消全部画宇宙任务",
    [Editor_Words["cancel_tasks_failed"]]: "取消任务失败",
    [Editor_Words["create_project_cancel_tasks_tip"]]:
      "新建项目将取消当前全部任务 😳 您确定要新建吗？",
    [Editor_Words["create_project_cancel_tasks_confirm"]]: "新建项目",
    [Editor_Words["cloud_switch_modal_update_time"]]: "更新于 $",
    [Editor_Words["cloud_switch_modal_current_project"]]: "当前项目",
    [Editor_Words["cloud_switch_modal_enter_project"]]: "进入项目",
    [Editor_Words["cloud_switch_modal_delete_project"]]: "删除项目",
    [Editor_Words["cloud_switch_modal_download_project"]]: "下载 .noli 到本地",
    [Editor_Words["cloud_switch_modal_load_more"]]: "滚动加载更多",
    [Editor_Words["cloud_project_header_op_icon_tooltip"]]: "项目操作",
    [Editor_Words["cloud_project_delete_modal_warn"]]: "确认删除“$”，一经删除将无法找回",
    [Editor_Words["cloud_project_delete_modal_confirm"]]: "删除",
    [Editor_Words["acg_generate_btn_text"]]: " 照片生成 AI 绘画",
    [Editor_Words["upload_image_to_board"]]: "上传本地图片到画板",
    [Editor_Words["Or"]]: "或",
    [Editor_Words["deliberate-general"]]: "通用大模型",
    [Editor_Words["epicrealisim-real"]]: "写实模型",
    [Editor_Words["anime"]]: "二次元模型",
    [Editor_Words["revanime-3d-anime"]]: "3D动漫模型",
    [Editor_Words["dreamlike"]]: "艺术模型",
    [Editor_Words["prompt-expand-modal-title"]]: "提示词智能扩写",
    [Editor_Words["prompt-expand-placeholder"]]:
      "输入简单描述词，如：狗、猫、花朵、风景等，AI 将为您生成一段适合生成图片的提示词，如果没有输入，将为您随机生成一段描述。",
    [Editor_Words["prompt-expand"]]: "智能生成描述文案",
  },
  en: {
    [Editor_Words["delete"]]: "Delete",
    [Editor_Words["size-reset"]]: "Size Reset",
    [Editor_Words["size-reset-no-need-message"]]:
      "Current Node is already at its original size! 😉",
    [Editor_Words["size-string-template"]]: "Selecting $1 Nodes",
    [Editor_Words["on-fire-message"]]:
      "The server is on fire 🔥 now! If you hate waiting, please hover the 'Contact Us' at the bottom-right corner and visit our GitHub, where you can learn how to deploy the models locally! 😆",
    [Editor_Words["task-limit-message"]]:
      "You have already submitted $1 tasks, and the server is on fire 🔥 now! Please wait for a while 😉",
    [Editor_Words["create-new-node"]]: "Create Blank Node",
    [Editor_Words["create-new-node-success-message"]]: "Created Succesfully! 🥳",
    [Editor_Words["loading-image-message"]]: "Image is still loading, please wait for a while 😉",
    [Editor_Words["cloud-save-success-message"]]: "Saved Successfully! 🥳",
    [Editor_Words["cloud-save-failed-message"]]: "Saved Failed! 😫",
    [Editor_Words["unrecognized-meta-type-warning-message"]]:
      "Unrecognized meta type occurred 😫: ",
    [Editor_Words["cannot-find-node-warning-message"]]:
      "Oops, we cannot find the specified Node 😫",
    [Editor_Words["max-wh-warning-message"]]: "Specified size$1exceeds maximum size$2! 😫",
    [Editor_Words["import-global"]]: "Import Project",
    [Editor_Words["download-global"]]: "Download Project",
    [Editor_Words["importing-global-message"]]: "Importing, please wait for a while 😉",
    [Editor_Words["import-global-success-message"]]: "Imported Successfully! 🥳",
    [Editor_Words["import-global-failed-message"]]: "Imported Failed! 😫",
    [Editor_Words["downloading-message"]]: "Downloading, please wait for a while 😉",
    [Editor_Words["auto-arrange"]]: "Auto Arrangement",
    [Editor_Words["auto-arrange-message"]]: "Arranging Nodes, please wait for a while 😉",
    [Editor_Words["current-node-type"]]: "Current Node Type",
    [Editor_Words["text-placeholder"]]: "Please input",
    [Editor_Words["noliFrame-placeholder"]]: "Please input",
    [Editor_Words["textarea-placeholder"]]: "Input Texts",
    [Editor_Words["import-placeholder"]]: "Input AI Parameters",
    [Editor_Words["txt2img-inpainting-placeholder"]]: "Input Replacement",
    [Editor_Words["negative-prompt-placeholder"]]: "Input Negative Prompt",
    [Editor_Words["no-node"]]: "None",
    [Editor_Words["blank-node"]]: "Blank Node",
    [Editor_Words["image-node"]]: "Image Node",
    [Editor_Words["download-image-size"]]: "Size",
    [Editor_Words["download-image-size-original"]]: "Original",
    [Editor_Words["download-image-size-on-board"]]: "On Board",
    [Editor_Words["num-tasks-in-queue"]]: "#Executing Tasks",
    [Editor_Words["num-tasks-message-prefix"]]: "Executing",
    [Editor_Words["num-tasks-message-postfix"]]: "AI Tasks",
    [Editor_Words["no-text-input-message"]]: "Text input needs to be provided 😉",
    [Editor_Words["no-selecting-node-message"]]: "Please select a Node first 😉",
    [Editor_Words["already-in-queue-message"]]:
      "This node / task is already in the execution queue, please wait patiently 😆",
    [Editor_Words["free-task-already-in-queue-message"]]:
      "This node / task is already in the execution queue, please wait patiently 😆",
    [Editor_Words["submit-success-message"]]:
      "Submit successfully! The results will be ready in 10-20 seconds, before that you can play around with other Nodes 😄",
    [Editor_Words["generate-success-message"]]: "Generated Successfully! 🥳",
    [Editor_Words["txt2img-sd-title"]]: "Text to Image",
    [Editor_Words["txt2img-title"]]: "Text to Image",
    [Editor_Words["txt2img-sd-submit-and-add"]]: "Generate & Add",
    [Editor_Words["txt2img-sd-submit-and-add-template"]]: "Generate $1 & Add",
    [Editor_Words["txt2img-sd-submit-and-fill"]]: "Generate & Fill",
    [Editor_Words["txt2img-sd-submit-and-sr"]]: "Generate SR & Add",
    [Editor_Words["txt2img-sd-tooltip"]]: "Generate a NEW image based on the text input",
    [Editor_Words["txt2img-sd-circular"]]: "Generate circular textures",
    [Editor_Words["txt2img-sd-anime"]]: "Use Anime-Finetuned Model",
    [Editor_Words["txt2img-sd-variation-title"]]: "Variation Generation",
    [Editor_Words["txt2img-sd-variation-submit"]]: "Generate",
    [Editor_Words["txt2img-sd-variation-submit-and-add-template"]]: "Generate $1 & Add",
    [Editor_Words["txt2img-sd-variation-not-support-message"]]:
      "Cannot generate similar picture for current Node 😫",
    [Editor_Words["txt2img-sd-style-title"]]: "Style",
    [Editor_Words["txt2img-sd-artist-title"]]: "Artist",
    [Editor_Words["txt2img-sd-size-title"]]: "Size",
    [Editor_Words["txt2img-sd-size-message"]]:
      "The size will be determined by the selected Node 😉",
    [Editor_Words["txt2img-sd-recommend-title"]]: "Try these out!",
    [Editor_Words["txt2img-sd-high-res"]]: "High Res",
    [Editor_Words["load-preset-success-message"]]: "Loaded Successfully! 🥳",
    [Editor_Words["img2img-sd-title"]]: "Image Translation",
    [Editor_Words["img2img-sd-submit"]]: "Translate",
    [Editor_Words["img2img-sd-submit-and-add-template"]]: "Translate $1 & Add",
    [Editor_Words["img2img-sd-tooltip"]]: "TRANSLATE the selected image with the text input",
    [Editor_Words["txt2img-inpainting-title"]]: "Erase & Replace",
    [Editor_Words["txt2img-inpainting-mark-image"]]: "Mark as Image",
    [Editor_Words["txt2img-inpainting-mark-mask"]]: "Mark as Replacement Mask",
    [Editor_Words["txt2img-inpainting-submit"]]: "Replace & Add",
    [Editor_Words["txt2img-inpainting-submit-and-add-template"]]: "Replace $1 & Add",
    [Editor_Words["fidelity"]]: "Fidelity",
    [Editor_Words["negative-prompt-title"]]: "Negative Prompt",
    [Editor_Words["negative-prompt-submit"]]: "Generate & Add",
    [Editor_Words["negative-prompt-not-support-message"]]:
      "Cannot apply Negative Prompt to current Node 😫",
    [Editor_Words["import-title"]]: "Parameters to Image",
    [Editor_Words["import-submit"]]: "Generate & Add",
    [Editor_Words["share-title"]]: "Share",
    [Editor_Words["copy-parameters"]]: "Copy",
    [Editor_Words["copy-parameters-success-message"]]: "Copied Successfully 🥳",
    [Editor_Words["download-parameters"]]: "Download Parameters",
    [Editor_Words.arrangeParameters]: "Arrange",
    [Editor_Words["image-process-title"]]: "Image Processing",
    [Editor_Words["super-resolution"]]: "Super Resolution",
    [Editor_Words["super-resolution-anime"]]: "Super Resolution (Anime)",
    [Editor_Words["picture-merging"]]: "Merge Pictures",
    [Editor_Words["picture-merging-mark-background"]]: "Mark as Background",
    [Editor_Words["picture-merging-mark-foreground"]]: "Mark as Foreground",
    [Editor_Words["picture-merging-submit"]]: "Merge",
    [Editor_Words["inpainting"]]: "Inpainting",
    [Editor_Words["inpainting-mark-image"]]: "Mark as Image",
    [Editor_Words["inpainting-mark-mask"]]: "Mark as Inpainting Mask",
    [Editor_Words["inpainting-submit"]]: "Inpaint",
    [Editor_Words["inpainting-refine-submit"]]: "Refine",
    [Editor_Words["outpainting"]]: "Outpainting",
    [Editor_Words["outpainting-mark-area"]]: "Mark as Outpainting Area",
    [Editor_Words["outpainting-submit"]]: "Outpaint",
    [Editor_Words["dropping-message"]]: "Detecting 🤔",
    [Editor_Words["uploading-message"]]: "Uploading, please wait for a while 😄",
    [Editor_Words["upload-seccess-message"]]: "Uploaded Successfully! 🥳",
    [Editor_Words["landscape-types"]]: "Landscape Types",
    [Editor_Words["landscape-clouds"]]: "Clouds",
    [Editor_Words["landscape-grass"]]: "Grass",
    [Editor_Words["landscape-hill"]]: "Hill",
    [Editor_Words["landscape-mountain"]]: "Mountain",
    [Editor_Words["landscape-river"]]: "River",
    [Editor_Words["landscape-rock"]]: "Rock",
    [Editor_Words["landscape-sea"]]: "Sea",
    [Editor_Words["landscape-sky-other"]]: "Sky",
    [Editor_Words["landscape-stone"]]: "Stone",
    [Editor_Words["landscape-tree"]]: "Tree",
    [Editor_Words["landscape-water-other"]]: "Water",
    [Editor_Words["landscape-ground-other"]]: "Ground",
    [Editor_Words["landscape-synthesis-submit"]]: "Landscape Synthesis",
    [Editor_Words["none-style"]]: "Any",
    [Editor_Words["oil-painting-style"]]: "oil painting",
    [Editor_Words["water-color-style"]]: "watercolor",
    [Editor_Words["sketch-style"]]: "sketch",
    [Editor_Words["cartoon-style"]]: "cartoon",
    [Editor_Words["chinese-painting-style"]]: "Chinese paingting",
    [Editor_Words["photograph-style"]]: "photography",
    [Editor_Words["anime-style"]]: "anime",
    [Editor_Words["neon-game-style"]]: "neon game",
    [Editor_Words["cg-style"]]: "CG",
    [Editor_Words["ghibli-style"]]: "ghibli",
    [Editor_Words["crystal-punk-style"]]: "crystal punk",
    [Editor_Words["psychedelic-style"]]: "psychedelic",
    [Editor_Words["low-poly-style"]]: "low poly",
    [Editor_Words["pixel-style"]]: "pixel",
    [Editor_Words["matte-painting-style"]]: "matte",
    [Editor_Words["interior-design-style"]]: "interior design",
    [Editor_Words["cyberpunk-style"]]: "cyberpunk",
    [Editor_Words["vaporwave-style"]]: "vaporwave",
    [Editor_Words["impressionism-style"]]: "impressionism",
    [Editor_Words["futurism-style"]]: "futurism",
    [Editor_Words["epic-style"]]: "epic",
    [Editor_Words["ukiyo-e-style"]]: "Ukiyo-e",
    [Editor_Words["retrowave-palette-style"]]: "retrowave",
    [Editor_Words["city-pop-style"]]: "80s city pop",
    [Editor_Words["chinese-new-style"]]: "Chinese new",
    [Editor_Words["none-artist"]]: "Any",
    [Editor_Words["daVinci-artist"]]: "da Vinci",
    [Editor_Words["van-gogh-artist"]]: "Van Gogh",
    [Editor_Words["vermeer-artist"]]: "Vermeer",
    [Editor_Words["rembrandt-artist"]]: "Rembrandt",
    [Editor_Words["durer-artist"]]: "Dürer",
    [Editor_Words["picasso-artist"]]: "Picasso",
    [Editor_Words["cezanne-artist"]]: "Cézanne",
    [Editor_Words["monet-artist"]]: "Monet",
    [Editor_Words["ingres-artist"]]: "J.-A.-D Ingres",
    [Editor_Words["mucha-artist"]]: "Mucha",
    [Editor_Words["ghibli-artist"]]: "Miyazaki Hayao",
    [Editor_Words["matisse-artist"]]: "Matisse",
    [Editor_Words["dali-artist"]]: "Dalí",
    [Editor_Words["mondrian-artist"]]: "Mondrian",
    [Editor_Words["fengzikai-artist"]]: "Zikai Feng",
    [Editor_Words["wuguanzhong-artist"]]: "Guanzhong Wu",
    [Editor_Words["zhangdaqian-artist"]]: "Daqian Zhang",
    [Editor_Words["recommend_1"]]: "rainbow bridge to the Nine Realms",
    [Editor_Words["recommend_2"]]: "cyberpunk city street",
    [Editor_Words["recommend_3"]]: "female winter goddess",
    [Editor_Words["recommend_4"]]: "retro sports car",
    [Editor_Words["recommend_5"]]: "goddess sleeping at meadow",
    [Editor_Words["recommend_6"]]: "colorful avatar",
    [Editor_Words["recommend_7"]]: "desert bloom",
    [Editor_Words["recommend_8"]]: "market stall at sunset",
    [Editor_Words["recommend_9"]]: "retro-futuristic steampunk city",
    [Editor_Words["recommend_10"]]: "dark mechanical citizen",
    [Editor_Words["recommend_11"]]: "beautiful model",
    [Editor_Words["recommend_12"]]: "stunning portrait of Green Lantern",
    [Editor_Words["recommend_13"]]: "portrait of magical lolita girl",
    [Editor_Words["recommend_14"]]: "woman of knowledge",
    [Editor_Words["recommend_15"]]: "portrait of a beautiful futuristic greek half god",
    [Editor_Words["recommend_16"]]: "weird god miracle",
    [Editor_Words["recommend_17"]]: "a veiled cybernetic cyborg",
    [Editor_Words["recommend_18"]]: "ruined abbey",
    [Editor_Words["recommend_19"]]: "fashion outfit concept design",
    [Editor_Words["recommend_20"]]: "cyborg vintage supercar",
    [Editor_Words["recommend_21"]]: "future urban design",
    [Editor_Words["recommend_22"]]: "manga style castle",
    [Editor_Words["recommend_23"]]: "ornate steampunk time machine",
    [Editor_Words["recommend_24"]]: "artwork disneyland illustration",
    [Editor_Words["recommend_25"]]: "intelligent biochemical laboratory",
    [Editor_Words["recommend_26"]]: "astronaut in futuristic dark and spaceship",
    [Editor_Words["recommend_27"]]: "gothic fantasy",
    [Editor_Words["generate-cats-panel-title"]]: "Generate Cats 🐱",
    [Editor_Words["generate-cats-category"]]: "Category",
    [Editor_Words["generate-cats-description"]]: "Supplementary",
    [Editor_Words["none-cat"]]: "Any",
    [Editor_Words["yingduan-cat"]]: "British shorthair",
    [Editor_Words["jiafei-cat"]]: "Exotic shorthair",
    [Editor_Words["buou-cat"]]: "Ragdoll",
    [Editor_Words["bosi-cat"]]: "Persian",
    [Editor_Words["xianluo-cat"]]: "Siamese",
    [Editor_Words["meiduan-cat"]]: "American Shorthair",
    [Editor_Words["jumao-cat"]]: "Chinese orange cat",
    [Editor_Words["xinjiapo-cat"]]: "Singapurar",
    [Editor_Words["ximalaya-cat"]]: "Himalaya",
    [Editor_Words["sikeke-cat"]]: "Selkirk Rex",
    [Editor_Words["zhonghuatianyuan-cat"]]: "Felis catus",
    [Editor_Words["mianyin-cat"]]: "MaineCoon",
    [Editor_Words["wumaomao-cat"]]: "Sphynx",
    [Editor_Words["node-type-error-message"]]: "Current Node type is weird 😫",
    [Editor_Words["negative-prompt-error-message"]]:
      "Cannot apply Negative Prompt on current Node 😫",
    [Editor_Words["import-error-message"]]: "Something is wrong with the parameters 😫",
    [Editor_Words["no-overlap-error-message"]]: "Overlap area is needed 😆",
    [Editor_Words["strange-image-error-message"]]: "Only jpg/png images are supported 😫",
    [Editor_Words["upload-image-error-message"]]: "Upload image failed 😫",
    [Editor_Words["upload-image-not-safe-warning-message"]]:
      "The uploaded image failed to pass the audit algorithm 😫",
    [Editor_Words["download-image-error-message"]]: "Download image failed 😫",
    [Editor_Words["landscape-synthesis-error-message"]]: "Landscape synthesis failed 😫",
    [Editor_Words["get-prompt-warning-message"]]:
      "The prompt optimizer is not working as expected 😫",
    [Editor_Words["get-prompt-not-safe-warning-message"]]:
      "The input prompt failed to pass the audit algorithm 😫",
    [Editor_Words["post-creator-error-message"]]:
      "Something is wrong when posting to the server, please try again 😫",
    [Editor_Words["post-creator-captcha-warn-message"]]:
      "For large amount of your tasks, the validation is triggered",
    [Editor_Words["post-creator-not-safe-warning-message"]]:
      "The generated image failed to pass the audit algorithm, please try again 😫",
    [Editor_Words["export-blob-error-message"]]: "Something is wrong when exporting Node 😫",
    [Editor_Words["update-op-error-message"]]: "Something is wrong when updating current Node 😫",
    [Editor_Words["add-blank-error-message"]]: "Something is wrong when adding Blank Node 😫",
    [Editor_Words["add-text-error-message"]]: "Something is wrong when adding Text Node 😫",
    [Editor_Words["add-image-error-message"]]: "Something is wrong when adding Image Node 😫",
    [Editor_Words["auto-arrange-no-need-message"]]: "There is no need to arrange the Nodes 😉",
    [Editor_Words["auto-arrange-no-nodes-message"]]: "There aren't any Nodes on the draw board 😫",
    [Editor_Words["EXCEED_LIMIT"]]: "Image size/resolution exceeds limit 😫",
    [Editor_Words["UN_SUPPORT"]]: "Only jpg/png images are supported 😫",
    [Editor_Words["PARSE_ERROR"]]: "Failed to parse the image 😫",
    [Editor_Words["use-local-server"]]: "Use Local Server",
    [Editor_Words["local-server-host"]]: "Server Host",
    [Editor_Words["use-local-model"]]: "Use Local Model",
    [Editor_Words["local-model-version"]]: "Version",
    [Editor_Words["local-model-name"]]: "Model",
    [Editor_Words["switch-local-model"]]: "Switch to Local Model",
    [Editor_Words["switch-local-model-submit-message"]]: "Switching to Local Model",
    [Editor_Words["switch-local-model-success-message"]]: "Successfully switched to local model 🥳",
    [Editor_Words["switch-local-model-error-message"]]: "Failed to switch to local model 😫",
    [Editor_Words["reset-local-model"]]: "Reset",
    [Editor_Words["reset-local-model-submit-message"]]: "Reseting Model",
    [Editor_Words["reset-local-model-success-message"]]: "Successfully reset model 🥳",
    [Editor_Words["reset-local-model-error-message"]]: "Failed to reset model 😫",
    [Editor_Words["local-model-root"]]: "Local Model Root",
    [Editor_Words["switch-local-model-root"]]: "Switch Model Root",
    [Editor_Words["switch-local-model-root-submit-message"]]: "Switching local model root",
    [Editor_Words["switch-local-model-root-success-message"]]:
      "Successfully switched local model root 🥳",
    [Editor_Words["switch-local-model-root-error-message"]]: "Failed to switch local model root 😫",
    [Editor_Words["tokens-root"]]: "Tokens Root",
    [Editor_Words["refresh-tokens"]]: "Refresh Tokens",
    [Editor_Words["refresh-tokens-submit-message"]]: "Refreshing tokens",
    [Editor_Words["refresh-tokens-success-message"]]: "Successfully refreshed tokens 🥳",
    [Editor_Words["refresh-tokens-error-message"]]: "Failed to refresh tokens 😫",
    [Editor_Words["creator-sd.inpainting-task"]]: "Erase & Replace",
    [Editor_Words["creator-outpainting-task"]]: "Outpainting",
    [Editor_Words["creator-inpainting-task"]]: "Inpainting",
    [Editor_Words["creator-semantic2img-task"]]: "Landscape Synthesis",
    [Editor_Words["creator-txt2img.variation-task"]]: "Variation(from Text)",
    [Editor_Words["creator-txt2img-task"]]: "Text to Image",
    [Editor_Words["creator-img2img.variation-task"]]: "Variation(from Image)",
    [Editor_Words["creator-img2img-task"]]: "Image Translation",
    [Editor_Words["creator-sr.anime-task"]]: "Super Resolution (Anime)",
    [Editor_Words["creator-sr-task"]]: "Super Resolution",
    [Editor_Words["creator-txt2img.inpainting-task"]]: "Erase & Replace",
    [Editor_Words["creator-txt2img.outpainting-task"]]: "Outpainting",
    [Editor_Words["creator-landscape-task"]]: "Landscape Synthesis",
    [Editor_Words["creator-working-message"]]: "(Executing)",
    [Editor_Words["pending-position"]]: "pending",
    [Editor_Words["pending-time"]]: "~",
    [Editor_Words["contact-us"]]: "Contact Us",
    [Editor_Words["join-community-message"]]: "Join Our Community",
    [Editor_Words["sponsor-message"]]: "Sponsor a Cup of Coffee",
    [Editor_Words["visit-github-message"]]: "Visit the GitHub Project",
    [Editor_Words["email-author-message"]]: "Email the Author",
    [Editor_Words["image-render-type"]]: "Fill Type",
    [Editor_Words["ai-parameters-appendix"]]: "Parameters",
    [Editor_Words["menu_link-to-gallery"]]: "Explore Gallery",
    [Editor_Words["header_link-to-gallery"]]: "Gallery",
    [Editor_Words["gen-img_link-to-gallery"]]: "Take Inspiration from Gallery",
    [Editor_Words["post-to-gallery"]]: "Share",
    [Editor_Words["message_post_sensitive-check-failed"]]:
      "According to the relevant content security regulations, the post failed. You can modify and try again",
    [Editor_Words["message_post_success"]]:
      "The work has been submitted for review, you can check the publication progress in My Space",
    [Editor_Words["message_post_failed"]]: "Something is wrong when posting to the server 😫",
    [Editor_Words["header_post-art-work"]]: "Post Art Work",
    [Editor_Words["label_title"]]: "Title",
    [Editor_Words["label_description"]]: "Description",
    [Editor_Words["label_prompt-public"]]: "Public Prompt",
    [Editor_Words["label_art-work"]]: "Work",
    [Editor_Words["explanation_prompt-public"]]:
      "Prompt, origin images, and other AI action parameters will be made public",
    [Editor_Words["tip_reorder-on-dragging"]]: "⭐️ You can holding and dragging image to reorder",
    [Editor_Words["button_cancel"]]: "Cancel",
    [Editor_Words["button_confirm-to-post"]]: "Confirm to Post",
    [Editor_Words["message_post-only-support-image"]]: "Only Support Image c",
    [Editor_Words["message_post-only-support-image-and-select-again"]]:
      "Only Support Image 😳 Please pick again",
    [Editor_Words["message_post-max-count-and-select-again"]]:
      "At most 9 images a time 😳 Please pick again",
    [Editor_Words["message_post-select"]]: "Pick some images to post 😉",
    [Editor_Words["validate_no-empty-title"]]: "Please give your Work a title  😉",
    [Editor_Words["validate_no-empty-description"]]: "Please write some description 😉",
    [Editor_Words["validate_title-over-limit"]]:
      "Title needs to be under 20 Chinese characters / 20 emojis / 40 English charactors 😳",
    [Editor_Words["validate_description-over-limit"]]:
      "Description needs to be under 140 Chinese characters / 140 emojis / 280 English charactors 😳",
    [Editor_Words["feedback"]]: "💡 Feedback",
    [Editor_Words["right-panel-tab-inspiration"]]: "Inspiration",
    [Editor_Words["right-panel-tab-operations"]]: "Operation",
    [Editor_Words["size"]]: "Size",
    [Editor_Words["stay-in-step-with-selected-pic"]]: "Determined by the selected Node",
    [Editor_Words["model"]]: "Model",
    [Editor_Words["resolution"]]: "Resolution",
    [Editor_Words["select-a-picture"]]: "Please select an image",
    [Editor_Words["select-a-ai-picture"]]: "Please select an AI generated image",
    [Editor_Words["anime-model"]]: "Nolibox Anime Model",
    [Editor_Words["anime-model-intro"]]: "Nolibox Anime Model (based on Stable Diffusion)",
    [Editor_Words["nolibox-model"]]: "Nolibox Model",
    [Editor_Words["nolibox-model-intro"]]: "Nolibox Model (based on Stable Diffusion)",
    [Editor_Words["dreamlike-model"]]: "Nolibox Model 2.0",
    [Editor_Words["dreamlike-model-intro"]]: "Nolibox Model 2.0 (based on Stable Diffusion)",
    [Editor_Words["left-nav-txt2img"]]: "Txt2Img",
    [Editor_Words["left-nav-variation"]]: "Variation",
    [Editor_Words["left-nav-img2img"]]: "Img2Img",
    [Editor_Words["left-nav-hd"]]: "HD",
    [Editor_Words["left-nav-inpaint"]]: "Erase & Replace",
    [Editor_Words["left-nav-eraser"]]: "Inpaint",
    [Editor_Words["left-nav-matting"]]: "Matting",
    [Editor_Words["left-nav-edit"]]: "Edit",
    [Editor_Words["left-nav-negative-prompt"]]: "Negative Prompt",
    [Editor_Words["left-nav-outpaint"]]: "Outpaint",
    [Editor_Words["left-nav-cat"]]: "Cat",
    [Editor_Words["left-nav-presets"]]: "Presets",
    [Editor_Words["left-nav-param"]]: "Params",
    [Editor_Words["choose-a-model"]]: "Choose a model",
    [Editor_Words["choose-negaprompt-source"]]: "Choose target image",
    [Editor_Words["negaprompt-input"]]: "Negative Prompt",
    [Editor_Words["params2txt-input-title"]]: "AI Params",
    [Editor_Words["params2txt-input-desc"]]:
      "You can copy your favorite image's parameters from Gallery",
    [Editor_Words["general-loading"]]: "Loading...",
    [Editor_Words["choose-super-resolution-source"]]: "Choose target image",
    [Editor_Words["img2img-placeholder-title"]]: "Image to be translate",
    [Editor_Words["img2img-prompt-title"]]: "Translation prompt",
    [Editor_Words["img2img-prompt-placeholder"]]: "Enter text, e.g.:A red rose, watercolor",
    [Editor_Words["prompt-for-img"]]: "Prompt for generation",
    [Editor_Words["current-select-not-image"]]: "Current selected node is not an image",
    [Editor_Words["current-select-not-ai-image"]]:
      "Current selected node is not an AI generated image",
    [Editor_Words["current_select_not_for_variation"]]: "当前选中的图片不支持相似功能",
    [Editor_Words["current_select_not_for_negative_prompt"]]: "当前选中的图片不支持去除功能",
    [Editor_Words["variation_usable_tooltip_text"]]:
      "相似功能可应用于由画宇宙模型、画宇宙动漫模型、画宇宙小模型生成的 AI 图片",
    [Editor_Words["negative_prompt_usable_tooltip_text"]]:
      "去除功能可应用于由画宇宙模型、画宇宙动漫模型、画宇宙小模型、社区大模型生成的AI图片",

    [Editor_Words["prompt-for-img-input-placeholder"]]: "Please describe the picture",
    [Editor_Words["local-replace-image-placeholder-title"]]: "Choose an image to erase and replace",
    [Editor_Words["local-erase-image-placeholder-title"]]: "Choose an image to inpainting",
    [Editor_Words["local-replace-mask-placeholder-title"]]: "Choose area to erase and replace",
    [Editor_Words["local-erase-mask-placeholder-title"]]: "Choose area to inpainting",
    [Editor_Words["select-a-path"]]: "Please select a sketch",
    [Editor_Words["current-select-not-path"]]: "Current selected node is not a sketch",
    [Editor_Words["local-replace-content"]]: "Content for replace",
    [Editor_Words["mode-simple"]]: "Simple",
    [Editor_Words["mode-advance"]]: "Advance",
    [Editor_Words["choose-a-mode"]]: "mode",
    [Editor_Words["action-guide-and-shortcut"]]: "Show Tips and Shortcut Key",
    [Editor_Words["prompt-word-table-title"]]: "Prompt Keywords: ",
    [Editor_Words["negative-prompt-word-table-title"]]: "Negative Prompt Keywords: ",
    [Editor_Words["prompt-input-title"]]: "Prompt for generation",
    [Editor_Words["negative-prompt-input-title"]]: "Negative Prompt",
    [Editor_Words["keyword-list-title"]]: "Keyword Content",
    [Editor_Words["use-keyword"]]: "use",
    [Editor_Words["using-keyword"]]: "using",
    [Editor_Words["image-content-categories"]]: "Image Content Category",
    [Editor_Words["select-a-picture-or-sketch"]]: "Please select an image or a sketch",
    [Editor_Words["current-select-not-a-picture-or-sketch"]]:
      "Current selected node is not an image or a sketch",
    [Editor_Words["header_menu_tip"]]: "Menu",
    [Editor_Words["header_add-blank_tip"]]: "Add Blank",
    [Editor_Words["header_add-text_tip"]]: "Add Text",
    [Editor_Words["header_normal-brush_tip"]]: "Sketch",
    [Editor_Words["header_landscape_tip"]]: "Landscape",
    [Editor_Words["header_undo_tip"]]: "Undo",
    [Editor_Words["header_redo_tip"]]: "Redo",
    [Editor_Words["header_cloud_tip"]]: "Save",
    [Editor_Words["search-not-found"]]: "Related content not found",
    [Editor_Words["negative-prompt-keyword-list-title"]]: "Remove Negative Effects",
    [Editor_Words["negative-prompt-keyword-search-placeholder"]]: "Search for a negative effect",
    [Editor_Words["prompt-keyword-search-placeholder"]]: "Search for an effect",
    [Editor_Words["select-all"]]: "Select all",
    [Editor_Words["optimizer"]]: "Optimizer",
    [Editor_Words["value-default"]]: "Default",
    [Editor_Words["value-custom"]]: "Custom",
    [Editor_Words["label_text_generate_count"]]: "Generate count",
    [Editor_Words["generate_count_option_label_template"]]: `$1`,
    [Editor_Words[
      "generate_count_option_label_tip_1"
    ]]: `由于同时生成多张图片对算力消耗较大，为保证用户体验 生成多张的功能仅对使用`,
    [Editor_Words["generate_count_option_label_tip_2"]]: "加速通道",
    [Editor_Words["generate_count_option_label_tip_3"]]: "的用户可用",
    [Editor_Words["outpainting-preview-title"]]: "Outpainting Area",
    [Editor_Words["outpainting-text-title"]]: "Prompt for generation",
    [Editor_Words["select-a-blank-node"]]: "Select a Blank Node",
    [Editor_Words["current-select-not-blank-node"]]: "Current selected Node is not a Blank Node",
    [Editor_Words["inspiration_tab_gallery"]]: "Gallery",
    [Editor_Words["inspiration_tab_album"]]: "Album",
    [Editor_Words["preset-type-acg"]]: "ACG Paints",
    [Editor_Words["preset-type-cat"]]: "Generate Cats",
    [Editor_Words["label_select_an_image"]]: "Select an image",
    [Editor_Words["label_select_style"]]: "Select a style",
    [Editor_Words["express_generate_btn_text"]]: "Generate",
    [Editor_Words["express_generate_btn_loading_text"]]: "Generating",
    [Editor_Words["img2promopt_failed_message"]]: "Failed to resolve the image 😫 please try again",
    [Editor_Words.presets_panel_title]: "Applications",
    /* 云端项目 */
    [Editor_Words["cloud_project_switch"]]: "Switch Project to ...",
    [Editor_Words["cloud_project_create"]]: "Create New Project",
    [Editor_Words["cloud_project_rename"]]: "Rename Project",
    [Editor_Words["cloud_project_rename_label"]]: "Rename current project as",
    [Editor_Words["cloud_project_rename_failed_toast"]]: "Failed to rename current project 😫",
    [Editor_Words["cloud_project_rename_success_toast"]]: "Successfully renamed project!",
    [Editor_Words["current_project_lost_id"]]: "Something went wrong with current project 😫",
    [Editor_Words["select_a_cloud_project"]]: "Please select a project",
    [Editor_Words["cloud_project_switch_header"]]: "Project Management",
    [Editor_Words["cancel_button"]]: "Cancel",
    [Editor_Words["switch_cloud_project_button_text"]]: "Switch",
    [Editor_Words["save_as_new_project_reason"]]:
      "Newer version is detected from cloud, your local project is saved as a new project: ",
    [Editor_Words["cloud_project_switch_success"]]: "Current project has already switched to",
    [Editor_Words["cloud_project_switch_failed"]]: "Failed to switch project 😫",
    [Editor_Words["cloud_project_create_success"]]:
      "New project created successfully, replacing project",
    [Editor_Words["cloud_project_create_failed"]]: "Failed to create a new project 😫",
    [Editor_Words["create_cloud_project_header"]]: "Create New Project",
    [Editor_Words["rename_for_new_project"]]: "nominate new project",
    [Editor_Words["create_new_project_button_text"]]: "Create",
    [Editor_Words["cloud_project_name_sensitive_toast"]]:
      "The project name contains sensitive word, please modify and try again",
    [Editor_Words["add-to-board-success-message"]]: "Added Successfully 🥳",
    [Editor_Words["add-to-board-error-message"]]: "Add image failed 😫",
    [Editor_Words.submitToPublic]: "Publish",
    [Editor_Words.current_select_is_not_origin_image]: "Current selected image is a cutout image",
    [Editor_Words.select_an_image_uncut]: "Please select an image which is not cutout",
    [Editor_Words.cutout_button_text]: "Cutout & Add",
    [Editor_Words.cutout_failed_message]: "Failed to cutout the image 😫",
    [Editor_Words.cutout_title]: "Cutout",
    [Editor_Words.cutouting_message]: "Cutout is going on...",
    [Editor_Words["cloud_project_shown_all"]]: "There's no more ~",
    [Editor_Words["end-brush"]]: "Finish",
    [Editor_Words["sampler-title"]]: "Sampler",
    [Editor_Words["num-steps-caption"]]: "Sample Steps",
    [Editor_Words["guidance-scale-caption"]]: "Guidance Scale",
    [Editor_Words["seed-caption"]]: "Seed",
    [Editor_Words.nolibox_matt_model]: "Nolibox Matting Model",
    [Editor_Words["cardboard-search"]]: "Key words",
    [Editor_Words["cardboard-search-placeholder"]]: "Search Key words",
    [Editor_Words["community-model"]]: "Community Model",
    [Editor_Words["community-model-provider"]]: "Community model supported by",
    [Editor_Words["monkey-product-name"]]: "InfMonkeys",
    [Editor_Words["technique-support"]]: "",
    [Editor_Words["creator-wenxin-task"]]: "Text to Image(Baidu Wenxin)",
    [Editor_Words["creator-wenxin-img2img-task"]]: "Image Translation(Baidu Wenxin)",
    [Editor_Words["creator-monkey-task"]]: "Text to Image(InfMonkeys)",
    [Editor_Words["creator-monkey-img2img-task"]]: "Image Translation(InfMonkeys)",
    [Editor_Words["cloud_save_tooltip_with_time"]]: "Save at $",
    [Editor_Words["cloud_save_info_with_time"]]: "Save at $",
    [Editor_Words["cloud_saving"]]: "Saving...",
    [Editor_Words["creator-draft-task"]]: "Text to Image(Draft)",
    [Editor_Words["creator-draft-img2img-task"]]: "Image Translation(Draft)",
    [Editor_Words["scroll_load_more"]]: "scroll to load more",
    [Editor_Words["cancel_all_nolibox_tasks"]]: "Cancel All Nolibox Tasks",
    [Editor_Words["replace_cancel_task_tip"]]:
      "All Nolibox tasks will be cancelled when replacing project 😳 are u sure to continue?",
    [Editor_Words["replace_cancel_tasks_confirm"]]: "Continue",
    [Editor_Words["replace_cancel_tasks_cancel"]]: "Cancel",
    [Editor_Words["cancel_tasks_success"]]: "All Nolibox tasks cancelled successfully",
    [Editor_Words["cancel_tasks_failed"]]: "Failed to cancel tasks 😫",
    [Editor_Words["create_project_cancel_tasks_tip"]]:
      "All Nolibox tasks will be cancelled when creating a new project 😳 are u sure to continue?",
    [Editor_Words["create_project_cancel_tasks_confirm"]]: "Continue",
    [Editor_Words["cloud_switch_modal_update_time"]]: "Update at $",
    [Editor_Words["cloud_switch_modal_current_project"]]: "Current project",
    [Editor_Words["cloud_switch_modal_enter_project"]]: "Switch",
    [Editor_Words["cloud_switch_modal_delete_project"]]: "Delete",
    [Editor_Words["cloud_switch_modal_download_project"]]: "download .noli",
    [Editor_Words["cloud_switch_modal_load_more"]]: "Load more",
    [Editor_Words["cloud_project_header_op_icon_tooltip"]]: "Project managment",
    [Editor_Words["cloud_project_delete_modal_warn"]]:
      "Do you confirm to delete project '$', this project can not be retrieved after deleted",
    [Editor_Words["cloud_project_delete_modal_confirm"]]: "Delete",
    [Editor_Words["acg_generate_btn_text"]]: " Generate From Photo",
    [Editor_Words["upload_image_to_board"]]: "Upload Image",
    [Editor_Words["Or"]]: "Or",
    [Editor_Words["deliberate-general"]]: "General",
    [Editor_Words["epicrealisim-real"]]: "Real",
    [Editor_Words["anime"]]: "Anime",
    [Editor_Words["revanime-3d-anime"]]: "3D Anime",
    [Editor_Words["dreamlike"]]: "DreamLike Art",
    [Editor_Words["prompt-expand-placeholder"]]:
      "Input simple prompt, such as: dog, cat, flower, landscape, etc., and AI will generate a prompt word suitable for generating pictures for you. If there is no input, it will randomly generate a prompt for you.",
    [Editor_Words["prompt-expand"]]: "Generate prompt",
    [Editor_Words["prompt-expand-modal-title"]]: "Prompt generation",
  },
};

export enum Editor_Gallery_Words {
  "search-placeholeder" = "search-placeholeder",
  "not-found-recommend" = "not-found-recommend",
  "check-detail" = "check-detail",
  "generete-same" = "generate-same",
  "search-sensitive-toast" = "search-sensitive-toast",
  "add-to-graph" = "add-to-graph",
}

export const editorGalleryLangRecords: Record<Lang, Record<Editor_Gallery_Words, string>> = {
  zh: {
    "check-detail": "查看详情",
    "generate-same": "生成同款",
    "not-found-recommend": "没有找到相关的内容，可以看看这些推荐👇",
    "search-placeholeder": "输入搜索关键词",
    "search-sensitive-toast": "当前搜索词内含有敏感词，请重新输入",
    "add-to-graph": "加入画板",
  },
  en: {
    "search-placeholeder": "Search for an image",
    "generate-same": "Get same",
    "check-detail": "Show detail",
    "not-found-recommend": "Relevant images not found, please view these recommendations 👇",
    "search-sensitive-toast": "Sensitive word found in your input , please retry 😫",
    "add-to-graph": "Add image",
  },
};

export enum Editor_Album_Words {
  "addToGraph" = "addToGraph",
  "editAlbumGroup" = "editAlbumGroup",
  "addToAlbum" = "addToAlbum",
  "myArtWork" = "myArtWork",
  "multiSelect" = "multiSelect",
  "exitMultiSelect" = "exitMultiSelect",
  "goBack" = "goBack",
  "add_success_toast" = "add_success_toast",
  "add_failed_toast" = "add_failed_toast",
  "arrangeInAlbum" = "arrangeInAlbum",
  "emptyAlbum" = "emptyAlbum",
}

export const editorAlbumLangRecords: Record<Lang, Record<Editor_Album_Words, string>> = {
  zh: {
    addToGraph: "加入画板",
    editAlbumGroup: "编辑分组",
    addToAlbum: "添加到画册",
    myArtWork: "我的作品",
    multiSelect: "多选",
    exitMultiSelect: "退出多选",
    goBack: "返回",
    add_success_toast: `选择的图片已加入“我的画册”`,
    add_failed_toast: "添加失败 😫",
    arrangeInAlbum: "到画册中整理",
    emptyAlbum: "暂无内容",
  },
  en: {
    addToGraph: "Add image",
    editAlbumGroup: "Edit Album",
    addToAlbum: "Add to Album",
    myArtWork: "My Art Work",
    multiSelect: "Multi-select",
    exitMultiSelect: "Exit-select",
    goBack: "Back",
    add_success_toast: `Added to Album successfully 🥳`,
    add_failed_toast: "Failed to collect in album, please retry 😫",
    arrangeInAlbum: "Arrange in Album",
    emptyAlbum: "Album is empty",
  },
};
